// ─── Domavix i18n ──────────────────────────────────────────
// Système de traduction maison FR / EN / NL-BE
// Usage : import { t, T } from './i18n'
//         t(lang, 'dashboard')

export const LANGS = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English',  flag: '🇬🇧' },
  { code: 'nl', label: 'Nederlands', flag: '🇧🇪' },
]

export const T = {

  // ── Navigation ───────────────────────────────────────────────
  fr: {
    // Nav
    dashboard:      'Tableau de bord',
    biens:          'Mes biens',
    locataires:     'Locataires',
    paiements:      'Loyers',
    messagerie:     'Messagerie',
    echeances:      'Échéances',
    baux:           'Types de baux',
    notifications:  'Notifications',
    parametres:     'Paramètres',
    pricing:        'Abonnement',
    gestion_loc:    'Gestion locative',

    // Auth
    bon_retour:     'Bon retour 👋',
    creer_compte:   'Créer un compte',
    acc_espace:     'Accède à ton espace propriétaire',
    commence_grat:  'Commence gratuitement',
    email:          'Email',
    mot_de_passe:   'Mot de passe',
    mdp_min:        '6 caractères minimum',
    se_connecter:   'Se connecter →',
    creer_mon_cpt:  'Créer mon compte →',
    deja_compte:    'Déjà un compte ?',
    pas_compte:     'Pas encore de compte ?',
    mdp_oublie:     'Mot de passe oublié ?',
    retour_cnx:     '← Retour à la connexion',
    envoi_lien:     'Envoyer le lien de réinitialisation →',
    email_mdp_ok:   '✅ Email de réinitialisation envoyé ! Vérifie ta boîte mail.',
    email_req:      'Email et mot de passe requis.',
    mdp_court:      'Mot de passe : 6 caractères minimum.',
    compte_cree:    '✅ Compte créé ! Vérifie ta boîte mail.',
    chgt_mdp:       'Changer mon mot de passe',
    deconnexion:    '→ Se déconnecter',
    email_envoye:   '✅ Email envoyé !',

     //Landing 
hero_eyebrow: "✦ Gestion locative simplifiée",
feat_sub: "Conçu pour les propriétaires qui gèrent eux-mêmes leur patrimoine immobilier.",
strip_6: "Sécurisé · Conforme RGPD",
cta_note: "🔒 Données sécurisées · Résiliation en 1 clic · Sans engagement",
footer_copy: "© 2026 Domavix",
auth_titre_login:   'Bon retour 👋',
auth_sub_login:     'Accède à ton espace propriétaire',
auth_titre_signup:  'Créer un compte',
auth_sub_signup:    'Commence gratuitement',
auth_email:         'Email',
auth_pwd:           'Mot de passe',
auth_pwd_min:       '6 caractères minimum',
auth_login_btn:     'Se connecter →',
auth_signup_btn:    'Créer mon compte →',
auth_reset_btn:     'Envoyer le lien de réinitialisation →',
auth_forgot:        'Mot de passe oublié ?',
auth_no_account:    'Pas encore de compte ?',
auth_create:        'Créer un compte',
auth_has_account:   'Déjà un compte ?',
auth_signin:        'Se connecter',
auth_back_login:    '← Retour à la connexion',
auth_err_fields:    'Email et mot de passe requis.',
auth_err_pwd_min:   'Mot de passe : 6 caractères minimum.',
auth_ok_signup:     '✅ Compte créé ! Vérifie ta boîte mail.',
auth_ok_reset:      '✅ Email de réinitialisation envoyé ! Vérifie ta boîte mail.',
auth_tagline:    'La gestion locative simple et efficace pour les propriétaires.',
auth_feat1_title: 'Tableau de bord en temps réel',
auth_feat1_desc:  'Loyers encaissés, retards, rendement.',
auth_feat2_title: 'Suivi des paiements',
auth_feat2_desc:  'Marque les loyers payés en un clic.',
auth_feat3_title: 'Quittances automatiques',
auth_feat3_desc:  'PDF en quelques secondes.',

    //Placeholder
    ph_adresse:       'Rue de la Paix 1, 1000 Bruxelles',
ph_loyer:         '950',
ph_charges:       '50',
ph_valeur:        '200000',
ph_prenom:        'Sophie',
ph_nom_loc:       'Martin',
ph_email:         'sophie@email.com',
ph_telephone:     '+32 470 00 00 00',
ph_profession:    'Ingénieur',
ph_employeur:     'Entreprise SA',
ph_contact_nom:   'Marie Dupont',
ph_notes:         'Observations, remarques…',
ph_notes_doc:     'Ex : signé le 01/01/2024',
ph_indice_ref:    'Ex: 892.29',
ph_indice_nom:    'Ex: ABEX Oct 2024',
ph_indice_ref2:   'Ex: ABEX, IRL, IPC',
ph_nom_bail:      'Ex: Bail résidentiel standard',
ph_note_ech:      'Ex: Bail 3-6-9, indexation ABEX',
ph_note_interne:  'Plombier contacté le…',
ph_proprio_nom:   'Jean Dupont',
ph_proprio_adr:   'Rue de la Paix 1',
ph_proprio_ville: 'Bruxelles 1000',
ph_proprio_tel:   '+32 470 00 00 00',

    // Dashboard
    tdb_titre:      'Tableau de bord',
    loyers_att:     'Loyers attendus',
    encaisses:      'Encaissés',
    biens_loc:      'Biens / Locataires actifs',
    retards:        'Retards',
    ce_mois:        'Ce mois-ci',
    a_relancer:     'À relancer',
    loyers_mois:    'Loyers du mois',
    voir_tout:      'Voir tout',
    loc_actifs:     'Locataires actifs',
    aucun_paie:     'Aucun paiement ce mois-ci',
    aucun_loc:      'Aucun locataire',
    annee:          'Année',
    enc_annuel:     'Encaissé',
    taux_recouv:    'Taux recouvrement',
    meilleur_mois:  'Meilleur mois',
    moy_mens:       'Moyenne mensuelle',
    sur_12_mois:    'Sur 12 mois',
    annee_compl:    'Année complète',
    attendus:       'attendus',
    aucun_enc:      'Aucun',
    enc_graph:      'Encaissements',
    rev_par_bien:   'Revenus par bien',
    aucun_enc_ann:  'Aucun encaissement pour',
    mois_en_cours:  'Mois en cours',
    encaisse_lbl:   'Encaissé',
    vide:           'Vide',

    // Biens
    mes_biens:      'Mes biens',
    todo:           'Tâches',
    illimites:      'Illimités',
    biens_util:     'biens utilisés',
    ajouter_bien:   '+ Ajouter un bien',
    annuler:        'Annuler',
    modifier_bien:  'Modifier le bien',
    ajouter_b:      '➕ Ajouter un bien',
    adresse:        'Adresse',
    type_bien:      'Type',
    loyer:          'Loyer (€)',
    charges:        'Charges (€)',
    valeur:         'Valeur (€)',
    jour_ech:       'Jour d\'échéance',
    le_du_mois:     'Le {j} du mois',
    enregistrer:    'Enregistrer',
    enreg_en_cours: 'Enregistrement...',
    modifier:       '✏️ Modifier',
    supprimer:      '🗑️',
    rdt:            'Rdt',
    adr_loyer_req:  'Adresse et loyer obligatoires.',
    aucun_bien:     'Aucun bien !',
    nb_biens:       'bien(s)',
    appartement:    'Appartement',
    studio:         'Studio',
    maison:         'Maison',
    kot:            'Kot',
    commerce:       'Commerce',

    // Locataires
    loc_titre:      'Locataires',
    actifs:         'actif(s)',
    inactifs:       'inactif(s)',
    limite:         'Limite',
    ajouter_loc:    '+ Ajouter un locataire',
    actifs_tab:     'Actifs',
    inactifs_tab:   'Inactifs',
    prenom:         'Prénom',
    nom:            'Nom',
    telephone:      'Téléphone',
    bien_loue:      'Bien loué',
    date_entree:    'Date d\'entrée *',
    tous_champs:    'Tous les champs obligatoires.',
    desactiver:     'Désactiver',
    reactiver:      'Réactiver',
    dossier:        '📁 Dossier',
    whatsapp:       'WhatsApp',
    aucun_loc_act:  'Aucun locataire actif.',
    aucun_loc_in:   'Aucun locataire inactif.',
    nb_loc:         'locataire(s)',
    sorti_le:       'Sorti le',
    pas_email:      'Pas d\'email',
    ajout_bien_dab: '⚠️ Ajoute d\'abord un bien.',
    selectionner:   '— Sélectionner —',
    langue:         'Langue',

    // Confirm modals
    confirmer:      'Confirmer',
    annuler_btn:    'Annuler',
    suppr_def:      'Supprimer définitivement {n} ? Irréversible.',
    desact_msg:     'Marquer {n} comme inactif ? Plus de loyers auto générés.',
    react_msg:      'Réactiver {n} comme locataire actif ?',
    suppr_btn:      'Supprimer',
    desact_btn:     'Désactiver',
    react_btn:      'Réactiver',

    // Dossier locataire
    informations:   'Informations',
    documents:      'Documents',
    invite:         'Inviter',
    invite_ok:      '✓ Invité',
    infos_base:     'Informations de base',
    infos_comp:     'Informations complémentaires',
    date_naiss:     'Date de naissance',
    num_nat:        'Numéro national',
    profession:     'Profession',
    employeur:      'Employeur',
    contact_urg:    'Contact urgence — Nom',
    contact_tel:    'Contact urgence — Tél',
    notes:          'Notes internes',
    bail:           'Bail',
    type_bail:      'Type de bail',
    date_sign:      'Date de signature',
    indice_ref:     'Indice de référence (valeur)',
    nom_indice:     'Nom de l\'indice',
    aucun:          '— Aucun —',
    enregistre:     '✅ Enregistré !',
    ajouter_doc:    'Ajouter un document',
    type_doc:       'Type de document',
    notes_opt:      'Notes (optionnel)',
    cliquer_fich:   'Cliquer pour sélectionner un fichier',
    formats_acc:    'PDF, JPG, PNG, Word — max 10 Mo',
    envoi_cours:    '⏳ Envoi en cours…',
    nb_docs:        'document(s)',
    aucun_doc:      'Aucun document pour ce locataire.',
    doc_locked:     '🔒 Les documents sont disponibles à partir du plan Starter.',
    chargement:     'Chargement…',
    votre_msg:      'Votre message…',
    envoyer:        'Envoyer',
    aucun_msg:      'Aucun message. Envoyez le premier !',
    vous:           'Vous',
    invitation_ok:  '✅ Invitation envoyée à {email} !',
    inv_error:      'Erreur lors de l\'envoi de l\'invitation.',
    inv_no_email:   'Ce locataire n\'a pas d\'email renseigné.',
    invit_le:       'Invité le',
    entre_le:       'Entré le',
    lang_comm: 'Langue de communication',
    emails_tab:        'Emails',
    emails_info:       'Historique de tous les emails envoyés à ce locataire.',
    emails_aucun:      'Aucun email envoyé pour ce locataire.',
    emails_nb:         'email(s) envoyé(s)',
    email_generation:  'Génération loyer',
    email_rappel:      'Rappel échéance',
    email_relance:     'Relance impayé',
    email_quittance:   'Quittance',
    email_envoye_lbl:  '✓ Envoyé',
    email_invitation: 'Invitation espace locataire',
    doc_limit_reached: 'Limite de {n} document(s) atteinte sur le plan {plan}.',
    doc_limit_upgrade: 'Passez au plan Pro pour des documents illimités.',

    // Paiements
    suivi_loyers:   'Suivi des loyers',
    enreg_manuel:   '+ Enregistrer manuellement',
    enc_total:      'Encaissé (total)',
    en_attente:     'En attente',
    soldes_part:    'Soldes partiels dus',
    en_retard:      'En retard',
    nb_paie:        'paiement(s)',
    tous:           'Tous',
    payes:          'Payés',
    partiels:       'Partiels',
    att_tab:        'En attente',
    retard_tab:     'En retard',
    paye_btn:       '✓ Payé',
    partiel_btn:    '~ Partiel',
    retard_btn:     'En retard',
    quittance_btn:  '📄 Quittance',
    rouvrir_btn:    '↩ Réouvrir',
    aucun_paie2:    'Aucun paiement',
    recu:           'reçu',
    du:             'dû',
    enreg_paie:     'Enregistrer un paiement',
    bien_req:       'Bien *',
    mois_req:       'Mois *',
    montant_req:    'Montant (€) *',
    statut:         'Statut',
    paye_s:         '✅ Payé',
    pending_s:      '⏳ En attente',
    late_s:         '🔴 En retard',
    champs_req:     'Tous les champs sont obligatoires.',
    bail_cat_369:   'Résidentiel 3-6-9 (France)',
    bail_cat_9ans:  'Habitation principale (9 ans)',
    bail_cat_court: 'Court terme (max 3 ans)',
    bail_cat_comm:  'Commercial',
    bail_cat_autre: 'Autre',
    erreur_envoi: 'Erreur lors de l\'envoi',

    // Partiel modal
    paie_partiel:   'Paiement partiel',
    loyer_att:      'Loyer attendu',
    montant_recu:   'Montant reçu (€)',
    recu_lbl:       '💸 Reçu',
    solde_rest:     'Solde restant',
    contact_support:      'Contacter le support',
    contact_support_desc: 'Question, bug ou idée ?',

    // Quittance
    quittance:      '📄 Quittance de loyer',
    locataire_lbl:  'Locataire',
    bien_lbl:       'Bien',
    periode:        'Période',
    montant_lbl:    'Montant',
    paye_le:        'Payé le',
    prop_incomplet: '⚠️ Complète tes infos propriétaire dans Paramètres avant de générer une quittance.',
    envoyer_email:  '✉️ Envoyer par email',
    dl_pdf:         '⬇️ Télécharger PDF',
    fermer:         'Fermer',
    envoi_ok:       '✅ Quittance envoyée à {email} !',
    envoi_err:      'Erreur lors de l\'envoi.',
    envoi_aussi:    'Envoyer aussi par email au locataire lors du téléchargement',
    no_email_loc:   '⚠️ Ce locataire n\'a pas d\'email renseigné.',
    envoi_en_cours: 'Envoi...',

    // Messagerie
    par_mois:       'mois',
    export_excel:   'Excel',
    msg_titre:      'Messagerie',
    msg_sub:        'Conversations avec vos locataires',
    nouveau_x:      'nouveau',
    nouveaux_x:     'nouveaux',
    conv_titre:     'conversation(s)',
    sel_conv:       'Sélectionnez une conversation',
    retour:         '← Retour',

    // Échéances
    ech_titre:      'Échéances',
    ech_sub:        'Renouvellements de bail et indexations à surveiller',
    ajouter_ech:    '+ Ajouter une échéance',
    mark_lues:      '✓ Marquer alertes lues',
    actives:        'Actives',
    traitees:       'Traitées',
    toutes:         'Toutes',
    ajouter_e:      'Ajouter une échéance',
    modifier_e:     'Modifier l\'échéance',
    locataire_req:  'Locataire *',
    type_req:       'Type',
    date_ech_req:   'Date d\'échéance *',
    rappel_av:      'Rappel (jours avant)',
    note_opt:       'Note (optionnel)',
    renouvellement: 'Renouvellement de bail',
    indexation:     'Indexation du loyer',
    traite_btn:     '✓ Traitée',
    aucune_ech:     'Aucune échéance',
    active_lbl:     'active',
    traitee_lbl:    'Traitée',
    depassee_lbl:   'Dépassée',

    // Indexation
     idx_menu: 'Indexation',
    idx_titre: 'Indexation des loyers',
    idx_soustitre: 'Calcul automatique selon l\'indice santé (Belgique)',
    idx_aucun: 'Aucun bail à indexer pour le moment.',
    idx_calculer: 'Calculer l\'indexation',
    idx_depassee: 'Échéance dépassée',
    idx_loyer_actuel: 'Loyer actuel',
    idx_indice_depart: 'Indice de départ',
    idx_nouvel_indice: 'Nouvel indice',
    idx_nouveau_loyer: 'Nouveau loyer',
    idx_voir_lettre: 'Voir le courrier au locataire',
    idx_appliquer: 'Appliquer l\'indexation',
    idx_application: 'Application',
    idx_envoyer: 'Envoyer au locataire',
    idx_envoye: 'Envoyé',
    idx_historique: 'Historique des indexations',
    idx_locataire: 'Locataire',
    idx_date: 'Date',
    idx_avant: 'Avant',
    idx_apres: 'Après',
    idx_verif_indices: 'Vérifiez que les indices du mois concerné sont bien renseignés.',
    idx_mail_objet: 'Indexation de votre loyer',
    idx_starter_desc: 'L\'indexation automatique des loyers est disponible dès le plan Starter. Calcul selon l\'indice santé et courrier pré-rempli au locataire.',
    pays_lbl: 'Pays',
    autre_pays: 'Autre',
    region_lbl: 'Région',
    region_wallonie: 'Wallonie',
    region_bruxelles: 'Bruxelles',
    region_flandre: 'Flandre',
    peb_lbl: 'PEB / Label énergétique',
    idx_hist_onglet: 'Évolution loyer',
    idx_hist_aucun: 'Aucune indexation enregistrée pour ce bail.',
    idx_hist_initial: 'Loyer initial',
    idx_hist_actuel: 'Loyer actuel',
    idx_hist_evolution: 'Évolution totale',
    idx_hist_indice: 'Indice',
    idx_hist_manuel: 'Modification manuelle',

    // Types de baux
    baux_titre:     'Types de baux',
    baux_sub:       'Modèles de baux avec génération automatique des échéances',
    nouveau_bail:   '+ Nouveau type de bail',
    nom_modele:     'Nom du modèle *',
    categorie:      'Catégorie',
    duree_mois:     'Durée (mois)',
    preavis:        'Préavis (mois)',
    rappel_renouv:  'Rappel renouvellement (jours avant)',
    index_auto:     'Indexation automatique',
    freq_mois:      'Fréquence (mois)',
    indice_ref2:    'Indice de référence',
    rappel_idx:     'Rappel indexation (jours avant)',
    creer_modele:   'Créer le modèle',
    modifier_b:     'Modifier',
    gen_ech:        '⚡ Générer échéances',
    aucun_bail:     'Aucun type de bail. Créez votre premier modèle !',
    assigner_bail:  'Assigner un bail à un locataire',
    assigner_info:  'ℹ️ En assignant un type de bail, les échéances seront générées automatiquement.',
    assigner_btn:   '⚡ Assigner et générer les échéances',
    bail_assigne:   '✅ Bail assigné et échéances générées !',
    traitement:     'Traitement...',
    locataires_c:   'locataire(s)',

    // Tâches récurrentes
        tr_vue_taches: 'À traiter',
    tr_vue_recurrentes: 'Entretien récurrent',
    tr_sous_titre: 'Planifiez vos entretiens et tâches répétitives.',
    tr_ajouter: 'Nouvelle tâche',
    tr_modele: 'Type de tâche',
    tr_titre: 'Intitulé',
    tr_bien: 'Bien concerné',
    tr_tous_biens: 'Tous les biens',
    tr_frequence: 'Fréquence',
    tr_mensuel: 'Tous les mois',
    tr_trimestriel: 'Tous les 3 mois',
    tr_semestriel: 'Tous les 6 mois',
    tr_annuel: 'Tous les ans',
    tr_2ans: 'Tous les 2 ans',
    tr_5ans: 'Tous les 5 ans',
    tr_prochaine: 'Prochaine échéance',
    tr_rappel: 'Rappel',
    tr_jours_avant: 'jours avant',
    tr_note: 'Note (optionnel)',
    tr_aucune: 'Aucune tâche récurrente. Ajoutez votre premier entretien.',
    tr_fait: 'Fait',
    tr_depassee: 'Dépassée',
    tr_starter_desc: 'La planification des entretiens récurrents est disponible dès le plan Starter. Programmez vos rappels d\'entretien chaudière, ramonage, assurance et plus.',

    // Calendrier
    cal_menu: 'Calendrier',
    cal_titre: 'Calendrier',
    cal_soustitre: 'Vos échéances de bail, indexations et entretiens en un coup d\'œil.',
    cal_starter_desc: 'Le calendrier unifié est disponible dès le plan Starter. Visualisez fins de bail, indexations et tâches d\'entretien sur une seule vue.',
    date_lbl: 'Date :',

    // Décompte charges
    ch_onglet: 'Charges',
    ch_annee: 'Année :',
    ch_ajouter: 'Ajouter une facture',
    ch_categorie: 'Catégorie',
    ch_montant: 'Montant',
    ch_date: 'Date facture',
    ch_libelle: 'Libellé',
    ch_libelle_ph: 'Ex : Facture eau Q1',
    ch_recuperable: 'Charge récupérable sur le locataire',
    ch_non_recup: 'Non récupérable',
    ch_aucune: 'Aucune facture enregistrée pour cette année.',
    ch_synthese: 'Décompte',
    ch_provisions: 'Provisions versées',
    ch_total_recup: 'Charges récupérables',
    ch_solde: 'Solde',
    ch_remboursement: 'À rembourser au locataire',
    ch_complement: 'Complément dû par le locataire',
    ch_reset_auto: 'Recalculer automatiquement',
    ch_enregistrer: 'Enregistrer le décompte',
    ch_envoyer: 'Envoyer au locataire',
    ch_envoye: 'Envoyé',
    ch_mail_objet: 'Décompte de charges',
    ch_annee_rattach: 'Année de rattachement',
    dont_charges: 'Dont charges',
    ch_pro_titre: 'Fonctionnalité Pro',
    ch_pro_desc: 'Le décompte de charges est disponible avec le plan Pro. Enregistrez vos factures et générez la régularisation annuelle automatiquement.',
    
    // Notifications
    notif_titre:    'Notifications',
    notif_sub:      'Configurez les emails automatiques envoyés à vos locataires.',
    vars_dispo:     'Variables utilisables dans vos modèles :',
    email_gen:      'Email de génération',
    le_1er_mois:    'le 1er du mois',
    sujet_loc:      'Sujet (email locataire)',
    corps_loc:      'Corps (email locataire)',
    rappel_ech:     'Rappel avant échéance',
    jours_avant:    'Envoyer combien de jours avant l\'échéance ?',
    relance_imp:    'Relance loyer impayé',
    jours_apres:    'Envoyer combien de jours après l\'échéance ?',
    enreg_notif:    'Enregistrer les paramètres',
    enreg_ok:       '✅ Paramètres enregistrés !',
    notif_templates_titre: 'Modèles d\'emails — envoyés dans la langue du locataire',
notif_templates_info:  'Chaque locataire reçoit l\'email dans sa propre langue (configurable dans son dossier).',
templates_titre: '✉️ Templates',
ech_arrive_le:    'arrive à échéance le',
ech_reste_jours:  'Il reste {n} jours pour agir.',


     // Interventions
    interv_titre:     'Demandes d\'intervention',
    interv_sub:       'Demandes soumises par vos locataires',
    interv_nouvelle:  'Nouvelle',
    interv_en_cours:  'En cours',
    interv_resolue:   'Résolue',
    interv_urgente:   '🔴 Urgente',
    interv_normale:   'Normale',
    interv_cat_elec:  'Électroménager',
    interv_cat_plomb: 'Plomberie',
    interv_cat_chauf: 'Chauffage',
    interv_cat_elec2: 'Électricité',
    interv_cat_autre: 'Autre',
    interv_repondre:  'Répondre',
    interv_resoudre:  'Marquer résolue',
    interv_note:      'Note interne',
    interv_aucune:    'Aucune demande d\'intervention',
    interv_prendre:   'Prendre en charge',
    interv_resolues: 'Résolues',
    voir_photo: 'Voir la photo',
    urgent: 'Urgent',
    par_email: 'par email',

    // Paramètres
    param_titre:    'Paramètres',
    param_sub:      'Ces informations apparaissent sur vos quittances et définissent le format des montants.',
    devise_fmt:     'Devise & Format',
    devise:         'Devise',
    apercu:         'Aperçu',
    infos_prop:     'Informations propriétaire',
    infos_prop_sub: 'Ces informations sont affichées sur toutes les quittances PDF générées.',
    nom_complet:    'Nom complet',
    ville:          'Ville',
    email_cpt:      'Email (compte)',
    langue_iface:   'Langue de l\'interface',
    langue_sub:     'L\'interface s\'affichera dans la langue sélectionnée.',
    lang_note:      '⚠️ La langue est appliquée après avoir cliqué sur "Enregistrer".',
    module_interv_on:  'Module activé',
    module_interv_off: 'Module désactivé',
    reset_email_info: 'Un email de réinitialisation sera envoyé à',
    module_interv_title: 'Module Interventions',
    module_interv_desc: 'Permettez à vos locataires de soumettre des demandes d\'intervention depuis leur portail.',
    zone_danger:          'Zone de danger',
    suppr_compte_desc:    'La suppression de votre compte est irréversible. Toutes vos données (biens, locataires, paiements, documents) seront définitivement effacées.',
    suppr_compte_confirm1:'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
    suppr_compte_confirm2:'Dernière confirmation : toutes vos données seront supprimées définitivement. Continuer ?',
    suppr_compte_btn:     'Supprimer mon compte',

    // Sign Up
    auth_err_cgu:       'Vous devez accepter les CGU pour créer un compte.',
    auth_cgu_label:     "J'accepte les",
    auth_cgu_link:      'Conditions Générales d\'Utilisation',
    auth_cgu_et:        'et la',
    auth_cgu_rgpd_link: 'Politique de confidentialité',

    // Onboarding
    onb_bienvenue:  'Bienvenue sur Domavix !',
    onb_sub:        'Votre espace de gestion locative est prêt. Suivez ces 3 étapes pour démarrer en moins de 2 minutes.',
    onb_plan_grat:  '⭐ Plan Gratuit — 1 bien, 1 locataire inclus',
        onb_t1:         'Ajoutez votre premier bien',
    onb_d1:         'Adresse, loyer, charges — 30 secondes.',
    onb_cta1:       '+ Ajouter un bien',
    onb_t2:         'Ajoutez un locataire',
    onb_d2:         'Associez-le à votre bien et fixez la date d\'entrée.',
    onb_cta2:       '+ Ajouter un locataire',
    onb_t3:         'Suivez vos loyers',
    onb_d3:         'Les loyers du mois sont générés automatiquement.',
    onb_cta3:       'Voir les loyers',
    onb_saviez:     '💡 Le saviez-vous ?',
    onb_tip1:       '🤖 Les loyers sont générés automatiquement le 1er de chaque mois',
    onb_tip2:       '📄 Générez des quittances PDF en un clic depuis la page Loyers',
    onb_tip3:       '📱 Domavix fonctionne aussi sur mobile — installez-le comme une app !',
    onb_tip4:       '🔔 Configurez des rappels email automatiques pour vos locataires',

    // Upgrade
    upg_titre:      'Fonctionnalité Pro',
    upg_desc:       'Cette fonctionnalité est réservée au plan Pro. Passez au Pro pour débloquer la messagerie, les échéances, les types de baux, les notifications et l\'espace locataire.',
    upg_btn:        'Voir le plan Pro →',
    lim_att:        'Limite du plan {plan} atteinte',
    voir_plans:     'Voir les plans',
    
    // Pricing
    prix_titre:     'Un prix simple, aucune surprise',
    prix_sub:       'Commence gratuitement. Passe à un plan payant quand tu veux, résilie à tout moment.',
    prix_badge:     'Gestion locative simplifiée',
    plan_act:       'Votre plan actuel',
    populaire:      '⭐ Le plus populaire',
    choisir:        'Choisir {plan} →',
    securise:       '🔒 Paiement sécurisé par Stripe · Résiliation en 1 clic · Aucun engagement',
    envoi_erreur: 'Erreur lors de l\'envoi de l\'email.',
    gerer_abonnement:     'Gérer mon abonnement →',
    gerer_abonnement_sub: 'Annuler, changer de plan ou mettre à jour votre moyen de paiement',
    cancel_warning_1:     'Votre abonnement',
    cancel_warning_2:     'est actif jusqu\'au',
    cancel_warning_3:     'Il passera ensuite en plan Gratuit.',

    // Plans
    plan_free_name:    'Gratuit',
    plan_free_period:  '/toujours',
    plan_free_desc:    'Pour découvrir Domavix avec un premier bien.',
    plan_starter_desc: 'Jusqu\'à 4 biens · Quittances PDF · Interventions · Export Excel · Notifications automatiques',
    plan_pro_desc:     'Jusqu\'à 10 biens · Messagerie locataires · Échéances & indexation · Baux · Synchronisation bancaire · Tout Starter inclus',

    // Features
    feat_1_bien:       '1 bien maximum',
    feat_5_biens:      '5 biens maximum',
    feat_10_biens: 'Jusqu\'à 10 biens',
    feat_biens_illim:  'Biens illimités',
    feat_1_loc:        '1 locataire',
    feat_loc_illim:    'Locataires illimités',
    feat_suivi:        'Suivi des loyers',
    feat_infos:        'Infos dossier locataire',
    feat_quittances:   'Quittances PDF',
    feat_docs_lock:    'Documents locataires',
    feat_notif:        'Notifications email',
    feat_3_docs:       '3 documents par locataire',
    feat_docs_illim:   'Documents illimités par locataire',
    feat_export_xl:    'Excel',
    feat_support:      'Support prioritaire',
    plan_enterprise_title: 'Plus de 10 biens ? Parlons-en.',
    plan_enterprise_desc:  'Tarif sur mesure, onboarding personnalisé, support dédié.',
    plan_enterprise_cta:   '✉️ Me contacter',
    feat_4_biens:       '4 biens maximum',
    feat_interventions: 'Gestion des interventions',
    feat_ponto:         'Identification auto des loyers (Ponto)',
    feat_messagerie:    'Messagerie locataires',
    feat_echeances:     'Échéances & indexation des loyers',
    feat_5_docs:        '5 documents par locataire (max 5 Mo)',
    feat_20_docs:       '20 documents par locataire (max 10 Mo)',
    doc_taille_max:     'Fichier trop volumineux. Maximum autorisé : {n} Mo',
    feat_indexation: 'Indexation automatique des loyers',
    feat_calendrier: 'Calendrier des échéances',
    feat_taches_rec: 'Tâches d\'entretien récurrentes',
    feat_charges: 'Décompte de charges annuel',

    // Immeuble
    imm_onglet: 'Immeubles',
    imm_sous_titre: 'Regroupez vos biens et répartissez les charges communes.',
    imm_ajouter: 'Nouvel immeuble',
    imm_nom: 'Nom de l\'immeuble',
    imm_nom_ph: 'Ex : Résidence Les Tilleuls',
    imm_adresse: 'Adresse',
    imm_cle: 'Clé de répartition',
    imm_cle_quotite: 'Quotités',
    imm_cle_surface: 'Surface (m²)',
    imm_cle_egale: 'Parts égales',
    imm_format: 'Format',
    imm_millieme: 'Millièmes (/1000)',
    imm_pourcent: 'Pourcentage (/100)',
    imm_lot: 'lot',
    imm_lots: 'lots',
    imm_vide_titre: 'Aucun immeuble',
    imm_vide_desc: 'Regroupez plusieurs biens en immeuble pour répartir automatiquement les charges communes (ascenseur, hall, chauffage collectif) entre les lots.',
    imm_aucun_lot: 'Aucun lot rattaché. Ajoutez un bien ci-dessous.',
    imm_rattacher: 'Choisir un bien à rattacher',
    imm_ajouter_lot: 'Rattacher',
    imm_total_alerte: 'Le total des quotités ({total}) ne fait pas {cible}.',
    imm_normalise: 'La répartition est calculée proportionnellement.',
    imm_col_bien: 'Bien',
    imm_col_quotite: 'Quotité',
    imm_col_surface: 'Surface',
    imm_col_part: 'Part',
    imm_enregistrer_quotites: 'Enregistrer',
    imm_enregistre: 'Enregistré',
    ch_privatives: 'Charges privatives',
    ch_quote_part: 'Quote-part charges communes',
    cc_titre: 'Charges communes',
    cc_ajouter: 'Facture',
    cc_aucune: 'Aucune facture commune pour cette année.',
    cc_total: 'Total charges communes',
    imm_cle_habitants: 'Nombre d\'habitants',
    cc_repartir: 'Répartir selon :',
    ch_presence: 'présence',
    idx_correction_titre: 'Correction PEB (Flandre)',
    idx_loyer_plein: 'Loyer indexé (formule standard)',
    idx_facteur: 'Facteur de correction',
    idx_loyer_corrige: 'Loyer corrigé dû',
    idx_irl_depart: 'IRL de départ',
    idx_irl_nouveau: 'Nouvel IRL',
    idx_gele_titre: 'Loyer gelé (passoire thermique)',
    idx_gele_inchange: 'le loyer reste inchangé',
    dpe_lbl: 'DPE (classe énergétique)',
    departement_lbl: 'Département',
    departement_ph: 'Ex : 75',
    irl_trimestre: 'Trimestre de référence IRL',
    irl_annee: 'Année de référence IRL',
    irl_auto: 'Auto (selon signature)',
    irl_zone_tendue: 'Logement en zone tendue (encadrement des loyers)',

    // FAQ
    faq_titre:  'Questions fréquentes',
    faq_q1:     'Puis-je changer de plan à tout moment ?',
    faq_a1:     'Oui, depuis ton espace Stripe. Les changements sont effectifs immédiatement.',
    faq_q2:     'Comment fonctionne la résiliation ?',
    faq_a2:     'Tu peux résilier en un clic depuis ton portail Stripe. Tu gardes accès jusqu\'à la fin de la période payée.',
    faq_q3:     'Mes données sont-elles sécurisées ?',
    faq_a3:     'Oui. Chaque propriétaire accède uniquement à ses données.',
    faq_q4:     'Proposez-vous une période d\'essai ?',
    faq_a4:     'Le plan gratuit te permet de tester sans limite de temps avec 1 bien. Pas de carte bancaire nécessaire.',

    // Types de documents
    doc_bail:          'Bail',
    doc_edl_entree:    'État des lieux entrée',
    doc_edl_sortie:    'État des lieux sortie',
    doc_caution:       'Caution',
    doc_attestation:   'Attestation domicile',
    doc_fiche_paie:    'Fiche de paie',
    doc_assurance:     'Assurance',
    doc_autre:         'Autre',

    un_mois_avant:     '1 mois avant',
    deux_mois_avant:   '2 mois avant',
    trois_mois_avant:  '3 mois avant',
    six_mois_avant:    '6 mois avant',
    quatorze_j_avant:  '14 jours avant',
    infos_complementaires: 'Informations complémentaires',
    desactivee:      'Désactivée',
    tous_les:        'Tous les',
    configurable:    'configurable',
    rappels:         'Rappels',
    sept_j_avant:    '7 jours avant',
    jan: 'Jan', fev: 'Fév', mar: 'Mar', avr: 'Avr', mai: 'Mai', jun: 'Jun',
    jul: 'Jul', aou: 'Aoû', sep: 'Sep', oct: 'Oct', nov: 'Nov', dec: 'Déc',

    upgrade_biens_free:    'Plan Gratuit : 1 bien max. Passez au Starter pour 4 biens.',
    upgrade_biens_starter: 'Plan Starter : 4 biens max. Passez au Pro pour des biens illimités.',
    upgrade_locs_free:     'Plan Gratuit : 1 locataire max. Passez au Starter pour des locataires illimités.',
    upgrade_limite_gen:    'Limite atteinte. Passez à un plan supérieur pour continuer.',
    upgrade_limite_lbl:    '🔒 Limite du plan {plan} atteinte',
    limite_lbl:            'Limite', 
    erreur_generique:'Erreur :',
    doc_limite_atteinte: 'Limite de {n} document(s) atteinte.',
    le_jour: 'le',
    interne: 'interne',
    passer_plan:           'Passer au plan {plan} ',
    passer_pro:            'Passer au plan Pro',
    starter_feature_titre: 'Fonctionnalité Starter',
    starter_feature_desc: "Les demandes d'intervention sont disponibles dès le plan Starter. Passez au Starter pour permettre à vos locataires de signaler des problèmes directement.",
    pro_feature_titre:     'Fonctionnalité Pro',
    pro_feature_desc:      'Cette fonctionnalité est réservée au plan Pro. Passez au Pro pour débloquer la messagerie, les échéances, les types de baux et les notifications.',
    voir_plan_pro:         'Voir le plan Pro →',
    modifier_locataire:    'Modifier le locataire',
    aucun_bien_loc:        'Aucun bien',
    erreur_upload:         'Erreur upload : ',
    supprimer_doc_confirm: 'Supprimer ce document ?',
    contenu_indispo:       'Contenu non disponible pour cet email.',
    adresse_loyer_req:     'Adresse et loyer obligatoires.',
    adresse_lbl:           'Adresse *',
    type_lbl:              'Type',
    loyer_eur_lbl:         'Loyer (€) *',
    charges_eur_lbl:       'Charges (€)',
    valeur_eur_lbl:        'Valeur (€)',
    biens_utilises:        '{n} / {max} biens utilisés',
    depass_biens:          '⚠️ Dépassement de plan — {n} biens pour {max}',
    depass_biens_desc:     'Vos biens existants restent accessibles mais vous ne pouvez plus en créer. Supprimez des biens ou passez à un plan supérieur.',
    champs_obligatoires:   'Tous les champs obligatoires.',
    depass_locs:           '⚠️ Dépassement de plan — {n} locataires actifs pour {max}',
    depass_locs_desc:      'Vos locataires existants restent accessibles mais vous ne pouvez plus en ajouter. Désactivez des locataires ou passez à un plan supérieur.',
    suppr_loc_confirm:     'Supprimer définitivement {prenom} {nom} ? Irréversible.',
    desact_loc_confirm:    'Marquer {prenom} {nom} comme inactif ? Plus de loyers auto générés.',
    react_loc_confirm:     'Réactiver {prenom} {nom} comme locataire actif ?',
    supprimer_btn:         'Supprimer',
    onb_titre:             'Bienvenue sur Domavix !',
    onb_plan_free:         '⭐ Plan Gratuit — 1 bien, 1 locataire inclus',
    onb_etape:             'Étape {n}',
    onb_step1_titre:       'Ajoutez votre premier bien',
    onb_step1_desc:        'Adresse, loyer, charges — 30 secondes.',
    onb_step2_titre:       'Ajoutez un locataire',
    onb_step2_desc:        'Associez-le à votre bien et fixez la date d\'entrée.',
    onb_step3_titre:       'Suivez vos loyers',
    onb_step3_desc:        'Les loyers du mois sont générés automatiquement.',
    voir_loyers:           'Voir les loyers',
    saviez_vous:           '💡 Le saviez-vous ?',
    tip1:                  '🤖 Les loyers sont générés automatiquement le 1er de chaque mois',
    tip2:                  '📄 Générez des quittances PDF en un clic depuis la page Loyers',
    tip3:                  '📱 Domavix fonctionne aussi sur mobile — installez-le comme une app !',
    tip4:                  '🔔 Configurez des rappels email automatiques pour vos locataires',
    suppr_bail_confirm:    'Supprimer ce type de bail ?',
    index_desactivee:      'Désactivée',
    traitement_en_cours:   'Traitement...',
    ech_no_bail:           'Ce locataire n\'a pas de type de bail assigné.',
    ech_bail_introuvable:  'Type de bail introuvable.',
    suppr_ech_confirm:     'Supprimer cette échéance ?',
    generer_suivante_msg:  'Voulez-vous générer automatiquement la prochaine échéance de {type} ?',
    non:                   'Non',
    oui_generer:           'Oui, générer',
    demandes:              'demande(s)',
    rouvrir:               'Rouvrir',
    repondre_placeholder:  'Répondre à {prenom}…',
    champs_paie_req:       'Tous les champs sont obligatoires.',
    ajouter_bien_first:    '⚠️ Ajoute d\'abord un bien.',
    nav_accueil:           'Accueil',
    nav_loyers:            'Loyers',
    nav_messages:          'Messages',
    nav_plus:              'Plus',
    nav_notifications:     'Notifications',
    nav_abonnement:        'Abonnement',
    cancel_warning:        'Votre abonnement {plan} est actif jusqu\'au {date}. Il passera ensuite en plan Gratuit.',
    voir_plans_btn:        'Voir les plans →',
    notif_activation:      'Activation',
    ajouter_bien_titre:    '➕ Ajouter un bien',
    ajouter_loc_titre:     '👤 Ajouter un locataire',
    messagerie_titre:      'Messagerie',
    actif_pour_linstant:   'actif pour l\'instant.',
    mois_idx:              'mois',
    bail_prefill_info: 'Les données de la fiche locataire et du bien sont pré-remplies automatiquement.',
    date_fin_bail: 'Date de fin (optionnel)',
    garantie_lbl: 'Garantie locative',
    garantie_mois_lbl: 'Mois de garantie',
    clauses_part: 'Clauses particulières',
    ph_clauses: 'Ex : animaux interdits, interdiction de fumer, modalités de stationnement...',
    bail_apercu: 'Aperçu du contrat',
    bailleur_lbl: 'Bailleur',
    generer_bail_btn: 'Générer le bail PDF',
    bail_coming_soon: 'La génération de baux sera disponible prochainement.',
    bail_disclaimer: 'Ce document est généré à titre indicatif. Il est recommandé de le faire vérifier par un professionnel ou un notaire avant signature.',
    loyers_retard:        'Loyers en retard',
    relances_envoyees:    'Relances envoyées',
    jamais_relances:      'Jamais relancés',
    jamais_relance_badge: 'Jamais relancé',
    derniere_relance:     'Dernière relance il y a',
    jour_s:               'jour(s)',
    actualiser:           '↺ Actualiser',
    aucun_retard:         '✅ Aucun loyer en retard',
    historique:           'Historique',
    relancer:             '📧 Relancer',
    relancer_nouveau:     '📧 Relancer à nouveau',
    connecter_banque:     '🏦 Connecter ma banque →',
    filtre_tous:          'Tous',
    filtre_relances:      '🔴 Relances',
    filtre_quittances:    '📄 Quittances',
    filtre_generation:    '📬 Génération',
    filtre_invitations:   '📨 Invitations',
    filtre_interventions: '🔧 Interventions',

    // Locations
     locations: 'Locations',

     // Dashboard nouveaux widgets
      dash_repartition:        'Répartition des paiements',
      dash_interventions:      'Interventions en cours',
      dash_aucune_interv:      '✅ Aucune intervention ouverte',
      dash_messages_nonlus:    'Messages non lus',
      dash_loyers_30j:         'Loyers attendus — 30 jours',
      dash_aucun_loyer_30j:    '✅ Aucun loyer attendu dans les 30 jours',
      dash_calendrier:         'Calendrier',
      dash_loyers_att_mois:    'Loyers attendus ce mois',
      dash_tout_encaisse:      '✅ Tout est encaissé',
      dash_encaisses_mois:     'Encaissés ce mois',
      dash_aucun_encaisse:     'Aucun loyer encaissé',

      // Locations (panneau)
      loc_panel_infos:         'Infos',
      loc_panel_bail:          'Bail',
      loc_panel_echeances:     'Échéances',
      loc_panel_paiements:     'Paiements',
      loc_nouvelle:            '+ Nouvelle location',
      loc_aucune:              'Aucune location',
      loc_active:              '✓ Active',
      loc_terminee:            'Terminée',
      loc_terminees:            'Terminées',
      loc_archivee:            'Archivée',
      loc_archivees:           'Archivées',
      loc_ouvrir:              'Ouvrir →',
      loc_terminer:            'Terminer',
      loc_reactiver:           'Réactiver',
      loc_archiver:            'Archiver',
      loc_duree:               'Durée',
      loc_debut:               'Début',
      loc_fin:                 'Fin',
      loc_garantie:            'Garantie',
      loc_loyer_charges:       'Loyer + charges',
      loc_aucune_ech:          'Aucune échéance · Renseignez le bail pour en générer.',
      loc_bail_attache:        '✓ Bail attaché',
      loc_generer_ech:         '📅 Générer les échéances',
      loc_generation_ech_info: '📅 Générez automatiquement les échéances de renouvellement et d\'indexation à partir des informations du bail.',
      loc_clauses:             'Clauses particulières',
      loc_bail_signe:          'Bail signé (PDF)',
      loc_attacher_bail:       'Cliquer pour attacher le bail signé',
      loc_total_encaisse:      'Total encaissé',
      loc_en_retard:           'En retard',
      loc_aucun_paiement:      'Aucun paiement enregistré.',
      loc_modifier_titre:      '✏️ Modifier la location',
      loc_confirm_terminer:    'Terminer la location de',
      loc_bail_requis: 'Veuillez renseigner le type de bail et la date de signature.',
      relancer_btn: 'Relancer',
      relance_ok:   'Relance envoyée ✓',

      // Corbeille
      corbeille_sous_titre:    'Les éléments sont supprimés définitivement après 30 jours',
      corbeille_vide:          '✅ La corbeille est vide',
      corbeille_suppr_def:     '⚠️ Suppression définitive',
      corbeille_suppr_confirm: 'Supprimer définitivement',
      corbeille_irrev:         '? Cette action est irréversible.',
      corbeille_suppr_btn:     'Supprimer définitivement',
      corbeille_restaurer:     '↩️ Restaurer',
      corbeille_supprime_le:   'Supprimé le',
      corbeille_dans:          'Suppression définitive dans',
      corbeille_imminente:     'Suppression imminente',
      corbeille_biens:         '🏠 Biens',
      corbeille_locataires:    '👤 Locataires',
      corbeille_locations:     '📋 Locations',
     corbeille: 'Corbeille',
     depuis:               'depuis',
    pdf_uniquement:       'PDF uniquement',
    loc_creer:            'Créer la location',
    todo_sub:             'Actions à effectuer sur votre portefeuille',
    todo_critique:        'Critiques',
    todo_a_traiter:       'À traiter',
    todo_informatif:      'Informatif',
    todo_total:           'Total',
    todo_ok:              '✅ Tout est à jour ! Aucune tâche en attente.',
    todo_vide_cat:        'Aucune tâche dans cette catégorie.',
    todo_aucun_doc:       'Aucun document dans le dossier',
    confirmer_btn:        '✓ Confirmer',
    refuser_btn:          '✕ Refuser',
    dash_aucun_msg_nonlu: '✅ Aucun message non lu',
    ponto_deconnecter:    'Déconnecter',
    ponto_sync_now:       '🔄 Synchroniser maintenant',
    ponto_compte:         'Compte Ponto connecté',
    ponto_jamais_sync:    'Jamais synchronisé',
    ponto_derniere_sync:  'Dernière sync :',
    ponto_connecte:       '✓ Connecté',
    ponto_sync_ok:        '✅ Synchronisation terminée',
    ponto_confirmer:      'À confirmer manuellement :',
    ponto_valider_dans:   'Ou validez dans',
    ponto_securise:       '🔒 Stocké de façon sécurisée · Jamais partagé',
    ponto_titre:       'Synchronisation bancaire',
    ponto_desc:        'Connectez votre compte bancaire Ponto pour détecter automatiquement les paiements reçus. Les loyers correspondants passent en Payé sans action manuelle.',
   actives_tab:          'Actives',
  },

  en: {
    // Nav
    dashboard:      'Dashboard',
    biens:          'My properties',
    locataires:     'Tenants',
    paiements:      'Rent',
    messagerie:     'Messaging',
    echeances:      'Deadlines',
    baux:           'Lease types',
    notifications:  'Notifications',
    parametres:     'Settings',
    pricing:        'Subscription',
    gestion_loc:    'Property management',

    // Auth
    bon_retour:     'Welcome back 👋',
    creer_compte:   'Create an account',
    acc_espace:     'Access your landlord dashboard',
    commence_grat:  'Start for free',
    email:          'Email',
    mot_de_passe:   'Password',
    mdp_min:        'At least 6 characters',
    se_connecter:   'Sign in →',
    creer_mon_cpt:  'Create my account →',
    deja_compte:    'Already have an account?',
    pas_compte:     'No account yet?',
    mdp_oublie:     'Forgot password?',
    retour_cnx:     '← Back to login',
    envoi_lien:     'Send reset link →',
    email_mdp_ok:   '✅ Reset email sent! Check your inbox.',
    email_req:      'Email and password are required.',
    mdp_court:      'Password must be at least 6 characters.',
    compte_cree:    '✅ Account created! Check your inbox.',
    chgt_mdp:       'Change my password',
    deconnexion:    '→ Sign out',
    email_envoye:   '✅ Email sent!',


    //Landing
    hero_eyebrow: "✦ Simplified property management",
feat_sub: "Designed for landlords who manage their own real estate portfolio.",
strip_6: "Secure · GDPR compliant",
cta_note: "🔒 Secure data · Cancel in 1 click · No commitment",
footer_copy: "© 2026 Domavix",
auth_titre_login:   'Welcome back 👋',
auth_sub_login:     'Access your landlord dashboard',
auth_titre_signup:  'Create an account',
auth_sub_signup:    'Start for free',
auth_email:         'Email',
auth_pwd:           'Password',
auth_pwd_min:       'Minimum 6 characters',
auth_login_btn:     'Sign in →',
auth_signup_btn:    'Create my account →',
auth_reset_btn:     'Send reset link →',
auth_forgot:        'Forgot password?',
auth_no_account:    'No account yet?',
auth_create:        'Create an account',
auth_has_account:   'Already have an account?',
auth_signin:        'Sign in',
auth_back_login:    '← Back to login',
auth_err_fields:    'Email and password required.',
auth_err_pwd_min:   'Password: minimum 6 characters.',
auth_ok_signup:     '✅ Account created! Check your inbox.',
auth_ok_reset:      '✅ Reset email sent! Check your inbox.',
auth_tagline:    'Simple and effective rental management for landlords.',
auth_feat1_title: 'Real-time dashboard',
auth_feat1_desc:  'Collected rents, late payments, yield.',
auth_feat2_title: 'Payment tracking',
auth_feat2_desc:  'Mark rents as paid in one click.',
auth_feat3_title: 'Automatic receipts',
auth_feat3_desc:  'PDF in seconds.',

    //Placeholder
    ph_adresse:       '1 Peace Street, London EC1A',
ph_loyer:         '950',
ph_charges:       '50',
ph_valeur:        '200000',
ph_prenom:        'Sophie',
ph_nom_loc:       'Martin',
ph_email:         'sophie@email.com',
ph_telephone:     '+44 7700 000000',
ph_profession:    'Engineer',
ph_employeur:     'Company Ltd',
ph_contact_nom:   'Marie Dupont',
ph_notes:         'Observations, remarks…',
ph_notes_doc:     'E.g.: signed on 01/01/2024',
ph_indice_ref:    'E.g.: 892.29',
ph_indice_nom:    'E.g.: ABEX Oct 2024',
ph_indice_ref2:   'E.g.: ABEX, IRL, CPI',
ph_nom_bail:      'E.g.: Standard residential lease',
ph_note_ech:      'E.g.: 3-6-9 lease, ABEX indexation',
ph_note_interne:  'Plumber contacted on…',
ph_proprio_nom:   'John Smith',
ph_proprio_adr:   '1 Peace Street',
ph_proprio_ville: 'London EC1A',
ph_proprio_tel:   '+44 7700 000000',

    // Dashboard
    tdb_titre:      'Dashboard',
    loyers_att:     'Expected rent',
    encaisses:      'Collected',
    biens_loc:      'Properties / Active tenants',
    retards:        'Late payments',
    ce_mois:        'This month',
    a_relancer:     'To follow up',
    loyers_mois:    'This month\'s rent',
    voir_tout:      'See all',
    loc_actifs:     'Active tenants',
    aucun_paie:     'No payments this month',
    aucun_loc:      'No tenants',
    annee:          'Year',
    enc_annuel:     'Collected',
    taux_recouv:    'Collection rate',
    meilleur_mois:  'Best month',
    moy_mens:       'Monthly average',
    sur_12_mois:    'Over 12 months',
    annee_compl:    'Full year',
    attendus:       'expected',
    aucun_enc:      'None',
    enc_graph:      'Collections',
    rev_par_bien:   'Revenue by property',
    aucun_enc_ann:  'No collections for',
    mois_en_cours:  'Current month',
    encaisse_lbl:   'Collected',
    vide:           'Empty',

    // Biens
    mes_biens:      'My properties',
    todo:           'Tasks',
    illimites:      'Unlimited',
    biens_util:     'properties used',
    ajouter_bien:   '+ Add a property',
    annuler:        'Cancel',
    modifier_bien:  'Edit property',
    ajouter_b:      '➕ Add a property',
    adresse:        'Address',
    type_bien:      'Type',
    loyer:          'Rent (€)',
    charges:        'Charges (€)',
    valeur:         'Value (€)',
    jour_ech:       'Due day',
    le_du_mois:     'The {j}th of the month',
    enregistrer:    'Save',
    enreg_en_cours: 'Saving...',
    modifier:       '✏️ Edit',
    supprimer:      '🗑️',
    rdt:            'Yield',
    adr_loyer_req:  'Address and rent are required.',
    aucun_bien:     'No properties!',
    nb_biens:       'property(ies)',
    appartement:    'Apartment',
    studio:         'Studio',
    maison:         'House',
    kot:            'Room',
    commerce:       'Commercial',

    // Locataires
    loc_titre:      'Tenants',
    actifs:         'active',
    inactifs:       'inactive',
    limite:         'Limit',
    ajouter_loc:    '+ Add a tenant',
    actifs_tab:     'Active',
    inactifs_tab:   'Inactive',
    prenom:         'First name',
    nom:            'Last name',
    telephone:      'Phone',
    bien_loue:      'Rented property',
    date_entree:    'Move-in date',
    tous_champs:    'All required fields must be filled.',
    desactiver:     'Deactivate',
    reactiver:      'Reactivate',
    dossier:        '📁 File',
    whatsapp:       'WhatsApp',
    aucun_loc_act:  'No active tenants.',
    aucun_loc_in:   'No inactive tenants.',
    nb_loc:         'tenant(s)',
    sorti_le:       'Left on',
    pas_email:      'No email',
    ajout_bien_dab: '⚠️ Please add a property first.',
    selectionner:   '— Select —',
    langue:         'Language',

    // Confirm modals
    confirmer:      'Confirm',
    annuler_btn:    'Cancel',
    suppr_def:      'Permanently delete {n}? This cannot be undone.',
    desact_msg:     'Mark {n} as inactive? No more auto-generated rent.',
    react_msg:      'Reactivate {n} as an active tenant?',
    suppr_btn:      'Delete',
    desact_btn:     'Deactivate',
    react_btn:      'Reactivate',

    // Dossier locataire
    informations:   'Information',
    documents:      'Documents',
    invite:         'Invite',
    invite_ok:      '✓ Invited',
    infos_base:     'Basic information',
    infos_comp:     'Additional information',
    date_naiss:     'Date of birth',
    num_nat:        'National number',
    profession:     'Profession',
    employeur:      'Employer',
    contact_urg:    'Emergency contact — Name',
    contact_tel:    'Emergency contact — Phone',
    notes:          'Internal notes',
    bail:           'Lease',
    type_bail:      'Lease type',
    date_sign:      'Signing date',
    indice_ref:     'Reference index (value)',
    nom_indice:     'Index name',
    aucun:          '— None —',
    enregistre:     '✅ Saved!',
    ajouter_doc:    'Add a document',
    type_doc:       'Document type',
    notes_opt:      'Notes (optional)',
    cliquer_fich:   'Click to select a file',
    formats_acc:    'PDF, JPG, PNG, Word — max 10 MB',
    envoi_cours:    '⏳ Uploading…',
    nb_docs:        'document(s)',
    aucun_doc:      'No documents for this tenant.',
    doc_locked:     '🔒 Documents are available from the Starter plan.',
    chargement:     'Loading…',
    votre_msg:      'Your message…',
    envoyer:        'Send',
    aucun_msg:      'No messages yet. Send the first one!',
    vous:           'You',
    invitation_ok:  '✅ Invitation sent to {email}!',
    inv_error:      'Error sending the invitation.',
    inv_no_email:   'This tenant has no email address.',
    invit_le:       'Invited on',
    entre_le:       'Moved in on',
    lang_comm: 'Communication language',
    emails_tab:        'Emails',
    emails_info:       'History of all emails sent to this tenant.',
    emails_aucun:      'No emails sent to this tenant yet.',
    emails_nb:         'email(s) sent',
    email_generation:  'Rent generation',
    email_rappel:      'Payment reminder',
    email_relance:     'Late payment follow-up',
    email_quittance:   'Receipt',
    email_envoye_lbl:  '✓ Sent',
    email_invitation: 'Tenant portal invitation',
    doc_limit_reached: 'Limit of {n} document(s) reached on the {plan} plan.',
    doc_limit_upgrade: 'Upgrade to Pro for unlimited documents.',

    // Paiements
    suivi_loyers:   'Rent tracking',
    enreg_manuel:   '+ Record manually',
    enc_total:      'Collected (total)',
    en_attente:     'Pending',
    soldes_part:    'Partial balances due',
    en_retard:      'Late',
    nb_paie:        'payment(s)',
    tous:           'All',
    payes:          'Paid',
    partiels:       'Partial',
    att_tab:        'Pending',
    retard_tab:     'Late',
    paye_btn:       '✓ Paid',
    partiel_btn:    '~ Partial',
    retard_btn:     'Late',
    quittance_btn:  '📄 Receipt',
    rouvrir_btn:    '↩ Reopen',
    aucun_paie2:    'No payments',
    recu:           'received',
    du:             'due',
    enreg_paie:     'Record a payment',
    bien_req:       'Property *',
    mois_req:       'Month *',
    montant_req:    'Amount (€) *',
    statut:         'Status',
    paye_s:         '✅ Paid',
    pending_s:      '⏳ Pending',
    late_s:         '🔴 Late',
    champs_req:     'All fields are required.',
    bail_cat_369:   'Residential 3-6-9 (France)',
    bail_cat_9ans:  'Main residence (9 years)',
    bail_cat_court: 'Short term (max 3 years)',
    bail_cat_comm:  'Commercial',
    bail_cat_autre: 'Other',
    erreur_envoi: 'Sending error',

    // Partiel modal
    paie_partiel:   'Partial payment',
    loyer_att:      'Expected rent',
    montant_recu:   'Amount received (€)',
    recu_lbl:       '💸 Received',
    solde_rest:     'Remaining balance',
    contact_support:      'Contact support',
    contact_support_desc: 'Question, bug or idea?',

    // Quittance
    quittance:      '📄 Rent receipt',
    locataire_lbl:  'Tenant',
    bien_lbl:       'Property',
    periode:        'Period',
    montant_lbl:    'Amount',
    paye_le:        'Paid on',
    prop_incomplet: '⚠️ Please complete your landlord info in Settings before generating a receipt.',
    envoyer_email:  '✉️ Send by email',
    dl_pdf:         '⬇️ Download PDF',
    fermer:         'Close',
    envoi_ok:       '✅ Receipt sent to {email}!',
    envoi_err:      'Error sending email.',
    envoi_aussi:    'Also send by email to tenant when downloading',
    no_email_loc:   '⚠️ This tenant has no email address.',
    envoi_en_cours: 'Sending...',

    // Messagerie
    par_mois:       'month',
    export_excel:   'Excel',
    msg_titre:      'Messaging',
    msg_sub:        'Conversations with your tenants',
    nouveau_x:      'new',
    nouveaux_x:     'new',
    conv_titre:     'conversation(s)',
    sel_conv:       'Select a conversation',
    retour:         '← Back',

    // Échéances
    ech_titre:      'Deadlines',
    ech_sub:        'Lease renewals and rent indexations to monitor',
    ajouter_ech:    '+ Add a deadline',
    mark_lues:      '✓ Mark alerts as read',
    actives:        'Active',
    traitees:       'Handled',
    toutes:         'All',
    ajouter_e:      'Add a deadline',
    modifier_e:     'Edit deadline',
    locataire_req:  'Tenant *',
    type_req:       'Type',
    date_ech_req:   'Deadline date *',
    rappel_av:      'Reminder (days before)',
    note_opt:       'Note (optional)',
    renouvellement: 'Lease renewal',
    indexation:     'Rent indexation',
    traite_btn:     '✓ Done',
    aucune_ech:     'No deadlines',
    active_lbl:     'active',
    traitee_lbl:    'Done',
    depassee_lbl:   'Overdue',

    // Indexation
     idx_menu: 'Indexation',
    idx_titre: 'Rent indexation',
    idx_soustitre: 'Automatic calculation based on the health index (Belgium)',
    idx_aucun: 'No lease to index at the moment.',
    idx_calculer: 'Calculate indexation',
    idx_depassee: 'Overdue',
    idx_loyer_actuel: 'Current rent',
    idx_indice_depart: 'Starting index',
    idx_nouvel_indice: 'New index',
    idx_nouveau_loyer: 'New rent',
    idx_voir_lettre: 'View tenant letter',
    idx_appliquer: 'Apply indexation',
    idx_application: 'Applying',
    idx_envoyer: 'Send to tenant',
    idx_envoye: 'Sent',
    idx_historique: 'Indexation history',
    idx_locataire: 'Tenant',
    idx_date: 'Date',
    idx_avant: 'Before',
    idx_apres: 'After',
    idx_verif_indices: 'Make sure the indices for the relevant month are filled in.',
    idx_mail_objet: 'Indexation of your rent',
    idx_starter_desc: 'Automatic rent indexation is available from the Starter plan. Health-index calculation and pre-filled tenant letter.',
    pays_lbl: 'Country',
    autre_pays: 'Other',
    region_lbl: 'Region',
    region_wallonie: 'Wallonia',
    region_bruxelles: 'Brussels',
    region_flandre: 'Flanders',
    peb_lbl: 'EPC / Energy label',
    idx_hist_onglet: 'Rent history',
    idx_hist_aucun: 'No indexation recorded for this lease.',
    idx_hist_initial: 'Initial rent',
    idx_hist_actuel: 'Current rent',
    idx_hist_evolution: 'Total change',
    idx_hist_indice: 'Index',
    idx_hist_manuel: 'Manual change',

    // Types de baux
    baux_titre:     'Lease types',
    baux_sub:       'Lease templates with automatic deadline generation',
    nouveau_bail:   '+ New lease type',
    nom_modele:     'Template name *',
    categorie:      'Category',
    duree_mois:     'Duration (months)',
    preavis:        'Notice period (months)',
    rappel_renouv:  'Renewal reminder (days before)',
    index_auto:     'Automatic indexation',
    freq_mois:      'Frequency (months)',
    indice_ref2:    'Reference index',
    rappel_idx:     'Indexation reminder (days before)',
    creer_modele:   'Create template',
    modifier_b:     'Edit',
    gen_ech:        '⚡ Generate deadlines',
    aucun_bail:     'No lease types. Create your first template!',
    assigner_bail:  'Assign a lease to a tenant',
    assigner_info:  'ℹ️ Assigning a lease type will automatically generate deadlines.',
    assigner_btn:   '⚡ Assign and generate deadlines',
    bail_assigne:   '✅ Lease assigned and deadlines generated!',
    traitement:     'Processing...',
    locataires_c:   'tenant(s)',

    // Tâches récurrentes
      tr_vue_taches: 'To do',
    tr_vue_recurrentes: 'Recurring maintenance',
    tr_sous_titre: 'Schedule your maintenance and repetitive tasks.',
    tr_ajouter: 'New task',
    tr_modele: 'Task type',
    tr_titre: 'Title',
    tr_bien: 'Related property',
    tr_tous_biens: 'All properties',
    tr_frequence: 'Frequency',
    tr_mensuel: 'Every month',
    tr_trimestriel: 'Every 3 months',
    tr_semestriel: 'Every 6 months',
    tr_annuel: 'Every year',
    tr_2ans: 'Every 2 years',
    tr_5ans: 'Every 5 years',
    tr_prochaine: 'Next due date',
    tr_rappel: 'Reminder',
    tr_jours_avant: 'days before',
    tr_note: 'Note (optional)',
    tr_aucune: 'No recurring task yet. Add your first maintenance.',
    tr_fait: 'Done',
    tr_depassee: 'Overdue',
    tr_starter_desc: 'Recurring maintenance scheduling is available from the Starter plan. Set up reminders for boiler servicing, chimney sweeping, insurance and more.',

    // Calendrier
    cal_menu: 'Calendar',
    cal_titre: 'Calendar',
    cal_soustitre: 'Your lease deadlines, indexations and maintenance at a glance.',
    cal_starter_desc: 'The unified calendar is available from the Starter plan. View lease ends, indexations and maintenance tasks in a single view.',
    date_lbl: 'Date:',

    // Décompte charges
    ch_onglet: 'Charges',
    ch_annee: 'Year:',
    ch_ajouter: 'Add an invoice',
    ch_categorie: 'Category',
    ch_montant: 'Amount',
    ch_date: 'Invoice date',
    ch_libelle: 'Description',
    ch_libelle_ph: 'E.g. Water bill Q1',
    ch_recuperable: 'Charge recoverable from tenant',
    ch_non_recup: 'Non-recoverable',
    ch_aucune: 'No invoice recorded for this year.',
    ch_synthese: 'Statement',
    ch_provisions: 'Provisions paid',
    ch_total_recup: 'Recoverable charges',
    ch_solde: 'Balance',
    ch_remboursement: 'To refund to tenant',
    ch_complement: 'Additional payment due by tenant',
    ch_reset_auto: 'Recalculate automatically',
    ch_enregistrer: 'Save statement',
    ch_envoyer: 'Send to tenant',
    ch_envoye: 'Sent',
    ch_mail_objet: 'Charges statement',
    ch_annee_rattach: 'Accounting year',
    dont_charges: 'Of which charges',
    ch_pro_titre: 'Pro feature',
    ch_pro_desc: 'Charges statements are available with the Pro plan. Record your invoices and generate the annual reconciliation automatically.',

    // Notifications
    notif_titre:    'Notifications',
    notif_sub:      'Configure automatic emails sent to your tenants.',
    vars_dispo:     'Variables available in your templates:',
    email_gen:      'Generation email',
    le_1er_mois:    'on the 1st of the month',
    sujet_loc:      'Subject (tenant email)',
    corps_loc:      'Body (tenant email)',
    rappel_ech:     'Reminder before deadline',
    jours_avant:    'How many days before the deadline?',
    relance_imp:    'Unpaid rent follow-up',
    jours_apres:    'How many days after the deadline?',
    enreg_notif:    'Save settings',
    enreg_ok:       '✅ Settings saved!',
    notif_templates_titre: 'Email templates — sent in the tenant\'s language',
  notif_templates_info:  'Each tenant receives the email in their own language (configurable in their file).',
  templates_titre: '✉️ Templates',
  ech_arrive_le:    'expires on',
ech_reste_jours:  '{n} days left to act.',

     // Interventions
    interv_titre:     'Maintenance requests',
    interv_sub:       'Requests submitted by your tenants',
    interv_nouvelle:  'New',
    interv_en_cours:  'In progress',
    interv_resolue:   'Resolved',
    interv_urgente:   '🔴 Urgent',
    interv_normale:   'Normal',
    interv_cat_elec:  'Appliances',
    interv_cat_plomb: 'Plumbing',
    interv_cat_chauf: 'Heating',
    interv_cat_elec2: 'Electricity',
    interv_cat_autre: 'Other',
    interv_repondre:  'Reply',
    interv_resoudre:  'Mark resolved',
    interv_note:      'Internal note',
    interv_aucune:    'No maintenance requests',
    interv_prendre:   'Take charge',
    interv_resolues: 'Resolved',
    voir_photo: 'View photo',
    urgent: 'Urgent',
    par_email: 'by email',

    // Paramètres
    param_titre:    'Settings',
    param_sub:      'This information appears on your receipts and defines amount formatting.',
    devise_fmt:     'Currency & Format',
    devise:         'Currency',
    apercu:         'Preview',
    infos_prop:     'Landlord information',
    infos_prop_sub: 'This information is displayed on all generated PDF receipts.',
    nom_complet:    'Full name',
    ville:          'City',
    email_cpt:      'Email (account)',
    langue_iface:   'Interface language',
    langue_sub:     'The interface will be displayed in the selected language.',
    lang_note:      '⚠️ The language is applied after clicking "Save".',
    module_interv_on:  'Module enabled',
    module_interv_off: 'Module disabled',
    reset_email_info: 'A reset email will be sent to',
    module_interv_title: 'Interventions Module',
    module_interv_desc: 'Allow your tenants to submit maintenance requests from their portal.',
    zone_danger:          'Danger zone',
    suppr_compte_desc:    'Deleting your account is irreversible. All your data (properties, tenants, payments, documents) will be permanently erased.',
    suppr_compte_confirm1:'Are you sure you want to delete your account? This action cannot be undone.',
    suppr_compte_confirm2:'Final confirmation: all your data will be permanently deleted. Continue?',
    suppr_compte_btn:     'Delete my account',

    // Sign Up
    auth_err_cgu:       'You must accept the Terms of Service to create an account.',
    auth_cgu_label:     'I accept the',
    auth_cgu_link:      'Terms of Service',
    auth_cgu_et:        'and the',
    auth_cgu_rgpd_link: 'Privacy Policy',

    // Onboarding
    onb_bienvenue:  'Welcome to Domavix!',
    onb_sub:        'Your property management dashboard is ready. Follow these 3 steps to get started in under 2 minutes.',
    onb_plan_grat:  '⭐ Free plan — 1 property, 1 tenant included',
    onb_t1:         'Add your first property',
    onb_d1:         'Address, rent, charges — 30 seconds.',
    onb_cta1:       '+ Add a property',
    onb_t2:         'Add a tenant',
    onb_d2:         'Link them to your property and set the move-in date.',
    onb_cta2:       '+ Add a tenant',
    onb_t3:         'Track your rent',
    onb_d3:         'Monthly rent is generated automatically.',
    onb_cta3:       'View rent',
    onb_saviez:     '💡 Did you know?',
    onb_tip1:       '🤖 Rent is automatically generated on the 1st of each month',
    onb_tip2:       '📄 Generate PDF receipts in one click from the Rent page',
    onb_tip3:       '📱 Domavix works on mobile too — install it as an app!',
    onb_tip4:       '🔔 Set up automatic email reminders for your tenants',

    // Upgrade
    upg_titre:      'Pro feature',
    upg_desc:       'This feature is reserved for the Pro plan. Upgrade to Pro to unlock messaging, deadlines, lease types, notifications and the tenant portal.',
    upg_btn:        'See Pro plan →',
    lim_att:        '{plan} plan limit reached',
    voir_plans:     'See plans',
    passer_plan:    'Upgrade to {plan} ',
    passer_pro:     'Upgrade to Pro',
    starter_feature_titre: 'Starter feature',
    starter_feature_desc: 'Maintenance requests are available from the Starter plan. Upgrade to let your tenants report issues directly.',

    // Pricing
    prix_titre:     'Simple pricing, no surprises',
    prix_sub:       'Start for free. Upgrade anytime, cancel anytime.',
    prix_badge:     'Simplified property management',
    plan_act:       'Your current plan',
    populaire:      '⭐ Most popular',
    choisir:        'Choose {plan} →',
    securise:       '🔒 Secure payment by Stripe · Cancel in 1 click · No commitment',
    envoi_erreur: 'Error sending email.',
    gerer_abonnement:     'Manage my subscription →',
    gerer_abonnement_sub: 'Cancel, change plan or update your payment method',
    cancel_warning_1:     'Your',
    cancel_warning_2:     'subscription is active until',
    cancel_warning_3:     'It will then switch to the Free plan.',

    // Plans
    plan_free_name:    'Free',
    plan_free_period:  '/forever',
    plan_free_desc:    'To discover Domavix with a first property.',
    plan_starter_desc: 'Up to 4 properties · PDF receipts · Maintenance requests · Excel export · Automatic notifications',
    plan_pro_desc:     'Up to 10 properties · Tenant messaging · Deadlines & indexation · Leases · Bank sync · All Starter included',
    // Features
    feat_1_bien:       '1 property maximum',
    feat_5_biens:      '5 properties maximum',
    feat_10_biens: 'Up to 10 properties',
    feat_biens_illim:  'Unlimited properties',
    feat_1_loc:        '1 tenant',
    feat_loc_illim:    'Unlimited tenants',
    feat_suivi:        'Rent tracking',
    feat_infos:        'Tenant file info',
    feat_quittances:   'PDF receipts',
    feat_docs_lock:    'Tenant documents',
    feat_notif:        'Email notifications',
    feat_3_docs:       '3 documents per tenant',
    feat_docs_illim:   'Unlimited documents per tenant',
    feat_export_xl:    'Excel',
    feat_support:      'Priority support',
    plan_enterprise_title: 'More than 10 properties? Let\'s talk.',
    plan_enterprise_desc:  'Custom pricing, personalized onboarding, dedicated support.',
    plan_enterprise_cta:   '✉️ Contact me',
    feat_4_biens:       '4 properties maximum',
    feat_interventions: 'Maintenance management',
    feat_ponto:         'Automatic rent detection (Ponto)',
    feat_messagerie:    'Tenant messaging',
    feat_echeances:     'Deadlines & rent indexation',
    feat_5_docs:        '5 documents per tenant (max 5 MB)',
    feat_20_docs:       '20 documents per tenant (max 10 MB)',
    doc_taille_max:     'File too large. Maximum allowed: {n} MB',
    feat_indexation: 'Automatic rent indexation',
    feat_calendrier: 'Deadlines calendar',
    feat_taches_rec: 'Recurring maintenance tasks',
    feat_charges: 'Annual charges statement',

    // Immeuble
    imm_onglet: 'Buildings',
    imm_sous_titre: 'Group your properties and split common charges.',
    imm_ajouter: 'New building',
    imm_nom: 'Building name',
    imm_nom_ph: 'E.g. Les Tilleuls Residence',
    imm_adresse: 'Address',
    imm_cle: 'Allocation key',
    imm_cle_quotite: 'Shares',
    imm_cle_surface: 'Surface (m²)',
    imm_cle_egale: 'Equal shares',
    imm_format: 'Format',
    imm_millieme: 'Thousandths (/1000)',
    imm_pourcent: 'Percentage (/100)',
    imm_lot: 'unit',
    imm_lots: 'units',
    imm_vide_titre: 'No building',
    imm_vide_desc: 'Group several properties into a building to automatically split common charges (lift, hall, collective heating) between the units.',
    imm_aucun_lot: 'No unit attached. Add a property below.',
    imm_rattacher: 'Choose a property to attach',
    imm_ajouter_lot: 'Attach',
    imm_total_alerte: 'The total of shares ({total}) does not equal {cible}.',
    imm_normalise: 'The allocation is calculated proportionally.',
    imm_col_bien: 'Property',
    imm_col_quotite: 'Share',
    imm_col_surface: 'Surface',
    imm_col_part: 'Portion',
    imm_enregistrer_quotites: 'Save',
    imm_enregistre: 'Saved',
    ch_privatives: 'Private charges',
    ch_quote_part: 'Share of common charges',
    cc_titre: 'Common charges',
    cc_ajouter: 'Invoice',
    cc_aucune: 'No common invoice for this year.',
    cc_total: 'Total common charges',
    imm_cle_habitants: 'Number of occupants',
    cc_repartir: 'Allocate by:',
    ch_presence: 'occupancy',
    idx_correction_titre: 'EPC correction (Flanders)',
    idx_loyer_plein: 'Indexed rent (standard formula)',
    idx_facteur: 'Correction factor',
    idx_loyer_corrige: 'Corrected rent due',
    idx_irl_depart: 'Starting IRL',
    idx_irl_nouveau: 'New IRL',
    idx_gele_titre: 'Rent frozen (energy sieve)',
    idx_gele_inchange: 'the rent remains unchanged',
    dpe_lbl: 'EPC (energy rating)',
    departement_lbl: 'Department',
    departement_ph: 'E.g. 75',
    irl_trimestre: 'IRL reference quarter',
    irl_annee: 'IRL reference year',
    irl_auto: 'Auto (based on signature)',
    irl_zone_tendue: 'Property in rent-control zone',

    // FAQ
    faq_titre:  'Frequently asked questions',
    faq_q1:     'Can I change plans at any time?',
    faq_a1:     'Yes, from your Stripe portal. Changes take effect immediately.',
    faq_q2:     'How does cancellation work?',
    faq_a2:     'You can cancel in one click from your Stripe portal. You keep access until the end of the paid period.',
    faq_q3:     'Is my data secure?',
    faq_a3:     'Yes. Each landlord only accesses their own data.',
    faq_q4:     'Do you offer a trial period?',
    faq_a4:     'The free plan lets you test indefinitely with 1 property. No credit card required.',

    // Types de documents
    doc_bail:          'Lease',
    doc_edl_entree:    'Move-in inspection',
    doc_edl_sortie:    'Move-out inspection',
    doc_caution:       'Security deposit',
    doc_attestation:   'Address certificate',
    doc_fiche_paie:    'Pay slip',
    doc_assurance:     'Insurance',
    doc_autre:         'Other',

    un_mois_avant:     '1 month before',
    deux_mois_avant:   '2 months before',
    trois_mois_avant:  '3 months before',
    six_mois_avant:    '6 months before',
    quatorze_j_avant:  '14 days before',
    infos_complementaires: 'Additional information',
    desactivee:      'Disabled',
    tous_les:        'Every',
    configurable:    'configurable',
    rappels:         'Reminders',
    sept_j_avant:    '7 days before',
    jan: 'Jan', fev: 'Feb', mar: 'Mar', avr: 'Apr', mai: 'May', jun: 'Jun',
    jul: 'Jul', aou: 'Aug', sep: 'Sep', oct: 'Oct', nov: 'Nov', dec: 'Dec',

    upgrade_biens_free:    'Free plan: 1 property max. Upgrade to Starter for 4 properties.',
    upgrade_biens_starter: 'Starter plan: 4 properties max. Upgrade to Pro for unlimited properties.',
    upgrade_locs_free:     'Free plan: 1 tenant max. Upgrade to Starter for unlimited tenants.',
    upgrade_limite_gen:    'Limit reached. Upgrade to continue.',
    upgrade_limite_lbl:    '🔒 {plan} plan limit reached',
    limite_lbl:            'Limit', 
    doc_limite_atteinte: 'Document limit of {n} reached.',
    erreur_generique:'Error :',
    le_jour: 'the',
    interne: 'internal',
    pro_feature_titre:     'Pro Feature',
    pro_feature_desc:      'This feature is reserved for the Pro plan. Upgrade to Pro to unlock messaging, deadlines, lease types and notifications.',
    voir_plan_pro:         'View Pro plan →',
    modifier_locataire:    'Edit tenant',
    aucun_bien_loc:        'No property',
    erreur_upload:         'Upload error: ',
    supprimer_doc_confirm: 'Delete this document?',
    contenu_indispo:       'Content not available for this email.',
    adresse_loyer_req:     'Address and rent are required.',
    adresse_lbl:           'Address *',
    type_lbl:              'Type',
    loyer_eur_lbl:         'Rent (€) *',
    charges_eur_lbl:       'Charges (€)',
    valeur_eur_lbl:        'Value (€)',
    biens_utilises:        '{n} / {max} properties used',
    depass_biens:          '⚠️ Plan exceeded — {n} properties for {max}',
    depass_biens_desc:     'Your existing properties remain accessible but you cannot create more. Delete properties or upgrade your plan.',
    champs_obligatoires:   'All fields are required.',
    depass_locs:           '⚠️ Plan exceeded — {n} active tenants for {max}',
    depass_locs_desc:      'Your existing tenants remain accessible but you cannot add more. Deactivate tenants or upgrade your plan.',
    suppr_loc_confirm:     'Permanently delete {prenom} {nom}? This cannot be undone.',
    desact_loc_confirm:    'Mark {prenom} {nom} as inactive? No more automatic rents generated.',
    react_loc_confirm:     'Reactivate {prenom} {nom} as an active tenant?',
    supprimer_btn:         'Delete',
    onb_titre:             'Welcome to Domavix!',
    onb_plan_free:         '⭐ Free plan — 1 property, 1 tenant included',
    onb_etape:             'Step {n}',
    onb_step1_titre:       'Add your first property',
    onb_step1_desc:        'Address, rent, charges — 30 seconds.',
    onb_step2_titre:       'Add a tenant',
    onb_step2_desc:        'Link them to your property and set the move-in date.',
    onb_step3_titre:       'Track your rents',
    onb_step3_desc:        'Monthly rents are generated automatically.',
    voir_loyers:           'View rents',
    saviez_vous:           '💡 Did you know?',
    tip1:                  '🤖 Rents are automatically generated on the 1st of each month',
    tip2:                  '📄 Generate PDF receipts in one click from the Rents page',
    tip3:                  '📱 Domavix also works on mobile — install it as an app!',
    tip4:                  '🔔 Set up automatic email reminders for your tenants',
    suppr_bail_confirm:    'Delete this lease type?',
    index_desactivee:      'Disabled',
    traitement_en_cours:   'Processing...',
    ech_no_bail:           'This tenant has no assigned lease type.',
    ech_bail_introuvable:  'Lease type not found.',
    suppr_ech_confirm:     'Delete this deadline?',
    generer_suivante_msg:  'Do you want to automatically generate the next {type} deadline?',
    non:                   'No',
    oui_generer:           'Yes, generate',
    demandes:              'request(s)',
    rouvrir:               'Reopen',
    repondre_placeholder:  'Reply to {prenom}…',
    champs_paie_req:       'All fields are required.',
    ajouter_bien_first:    '⚠️ Add a property first.',
    nav_accueil:           'Home',
    nav_loyers:            'Rents',
    nav_messages:          'Messages',
    nav_plus:              'More',
    nav_notifications:     'Notifications',
    nav_abonnement:        'Subscription',
    cancel_warning:        'Your {plan} subscription is active until {date}. It will then switch to the Free plan.',
    voir_plans_btn:        'View plans →',
    notif_activation:      'Activation',
    ajouter_bien_titre:    '➕ Add a property',
    ajouter_loc_titre:     '👤 Add a tenant',
    messagerie_titre:      'Messaging',
    actif_pour_linstant:   'active for now.',
    mois_idx:              'months',
    bail_prefill_info: 'Tenant and property data are pre-filled automatically.',
    date_fin_bail: 'End date (optional)',
    garantie_lbl: 'Security deposit',
    garantie_mois_lbl: 'Months of deposit',
    clauses_part: 'Special clauses',
    ph_clauses: 'e.g. no pets, no smoking, parking terms...',
    bail_apercu: 'Contract preview',
    bailleur_lbl: 'Landlord',
    generer_bail_btn: 'Generate lease PDF',
    bail_coming_soon: 'Lease generation will be available soon.',
    bail_disclaimer: 'This document is generated for informational purposes. It is recommended to have it reviewed by a professional or notary before signing.',
    loyers_retard:        'Late rents',
    relances_envoyees:    'Reminders sent',
    jamais_relances:      'Never reminded',
    jamais_relance_badge: 'Never reminded',
    derniere_relance:     'Last reminder',
    jour_s:               'day(s) ago',
    actualiser:           '↺ Refresh',
    aucun_retard:         '✅ No late rents',
    historique:           'History',
    relancer:             '📧 Remind',
    relancer_nouveau:     '📧 Remind again',
    connecter_banque:     '🏦 Connect my bank →',
    filtre_tous:          'All',
    filtre_relances:      '🔴 Reminders',
    filtre_quittances:    '📄 Receipts',
    filtre_generation:    '📬 Generation',
    filtre_invitations:   '📨 Invitations',
    filtre_interventions: '🔧 Interventions',

    // Locations
     locations: 'Tenancies',

     // Dashboard nouveaux widgets
    dash_repartition:        'Payment breakdown',
    dash_interventions:      'Ongoing interventions',
    dash_aucune_interv:      '✅ No open interventions',
    dash_messages_nonlus:    'Unread messages',
    dash_loyers_30j:         'Expected rent — 30 days',
    dash_aucun_loyer_30j:    '✅ No rent expected in the next 30 days',
    dash_calendrier:         'Calendar',
    dash_loyers_att_mois:    'Expected rent this month',
    dash_tout_encaisse:      '✅ All collected',
    dash_encaisses_mois:     'Collected this month',
    dash_aucun_encaisse:     'No rent collected',

    // Locations (panneau)
    loc_panel_infos:         'Info',
    loc_panel_bail:          'Lease',
    loc_panel_echeances:     'Deadlines',
    loc_panel_paiements:     'Payments',
    loc_nouvelle:            '+ New tenancy',
    loc_aucune:              'No tenancies',
    loc_active:              '✓ Active',
    loc_terminee:            'Ended',
    loc_archivees:     'Archived',
    loc_archivee:            'Archived',
    loc_ouvrir:              'Open →',
    loc_terminer:            'End',
    loc_reactiver:           'Reactivate',
    loc_archiver:            'Archive',
    loc_duree:               'Duration',
    loc_debut:               'Start',
    loc_fin:                 'End',
    loc_garantie:            'Deposit',
    loc_loyer_charges:       'Rent + charges',
    loc_aucune_ech:          'No deadlines · Fill in the lease to generate some.',
    loc_bail_attache:        '✓ Lease attached',
    loc_generer_ech:         '📅 Generate deadlines',
    loc_generation_ech_info: '📅 Automatically generate renewal and indexation deadlines from the lease information.',
    loc_clauses:             'Special clauses',
    loc_bail_signe:          'Signed lease (PDF)',
    loc_attacher_bail:       'Click to attach the signed lease',
    loc_total_encaisse:      'Total collected',
    loc_en_retard:           'Late',
    loc_aucun_paiement:      'No payments recorded.',
    loc_modifier_titre:      '✏️ Edit tenancy',
    loc_confirm_terminer:    'End the tenancy of',
    loc_bail_requis: 'Please fill in the lease type and signing date.',
    relancer_btn: 'Send reminder',
    relance_ok:   'Reminder sent ✓',

    // Corbeille
    corbeille_sous_titre:    'Items are permanently deleted after 30 days',
    corbeille_vide:          '✅ Trash is empty',
    corbeille_suppr_def:     '⚠️ Permanent deletion',
    corbeille_suppr_confirm: 'Permanently delete',
    corbeille_irrev:         '? This action cannot be undone.',
    corbeille_suppr_btn:     'Permanently delete',
    corbeille_restaurer:     '↩️ Restore',
    corbeille_supprime_le:   'Deleted on',
    corbeille_dans:          'Permanent deletion in',
    corbeille_imminente:     'Deletion imminent',
    corbeille_biens:         '🏠 Properties',
    corbeille_locataires:    '👤 Tenants',
    corbeille_locations:     '📋 Tenancies',
     corbeille: 'Trash',
     depuis:               'since',
    pdf_uniquement:       'PDF only',
    loc_creer:            'Create tenancy',
    todo_sub:             'Actions to take on your portfolio',
    todo_critique:        'Critical',
    todo_a_traiter:       'To handle',
    todo_informatif:      'Informational',
    todo_total:           'Total',
    todo_ok:              '✅ All up to date! No pending tasks.',
    todo_vide_cat:        'No tasks in this category.',
    todo_aucun_doc:       'No documents in the file',
    confirmer_btn:        '✓ Confirm',
    refuser_btn:          '✕ Refuse',
    dash_aucun_msg_nonlu: '✅ No unread messages',
    ponto_deconnecter:    'Disconnect',
    ponto_sync_now:       '🔄 Sync now',
    ponto_compte:         'Ponto account connected',
    ponto_jamais_sync:    'Never synced',
    ponto_derniere_sync:  'Last sync:',
    ponto_connecte:       '✓ Connected',
    ponto_sync_ok:        '✅ Sync complete',
    ponto_confirmer:      'To confirm manually:',
    ponto_valider_dans:   'Or validate in',
    ponto_securise:       '🔒 Stored securely · Never shared',
    ponto_titre:       'Bank synchronisation',
    ponto_desc:        'Connect your Ponto bank account to automatically detect received payments. Matching rents are marked as Paid without any manual action.',
    actives_tab:          'Active',
  },

  nl: {
    // Nav
    dashboard:      'Dashboard',
    biens:          'Mijn panden',
    locataires:     'Huurders',
    paiements:      'Huur',
    messagerie:     'Berichten',
    echeances:      'Vervaldagen',
    baux:           'Huurcontracten',
    notifications:  'Meldingen',
    parametres:     'Instellingen',
    pricing:        'Abonnement',
    gestion_loc:    'Vastgoedbeheer',

    // Auth
    bon_retour:     'Welkom terug 👋',
    creer_compte:   'Account aanmaken',
    acc_espace:     'Toegang tot uw verhuurdersdashboard',
    commence_grat:  'Gratis beginnen',
    email:          'E-mail',
    mot_de_passe:   'Wachtwoord',
    mdp_min:        'Minimaal 6 tekens',
    se_connecter:   'Inloggen →',
    creer_mon_cpt:  'Account aanmaken →',
    deja_compte:    'Al een account?',
    pas_compte:     'Nog geen account?',
    mdp_oublie:     'Wachtwoord vergeten?',
    retour_cnx:     '← Terug naar inloggen',
    envoi_lien:     'Resetlink verzenden →',
    email_mdp_ok:   '✅ Reset-e-mail verzonden! Controleer uw inbox.',
    email_req:      'E-mail en wachtwoord zijn verplicht.',
    mdp_court:      'Wachtwoord moet minimaal 6 tekens bevatten.',
    compte_cree:    '✅ Account aangemaakt! Controleer uw inbox.',
    chgt_mdp:       'Wachtwoord wijzigen',
    deconnexion:    '→ Uitloggen',
    email_envoye:   '✅ E-mail verzonden!',


    //Landing 
hero_eyebrow: "✦ Vereenvoudigd vastgoedbeheer",
feat_sub: "Ontworpen voor verhuurders die hun vastgoed zelf beheren.",
strip_6: "Beveiligd · GDPR-conform",
cta_note: "🔒 Beveiligde gegevens · Opzeggen met 1 klik · Geen verbintenis",
footer_copy: "© 2026 Domavix",
auth_titre_login:   'Welkom terug 👋',
auth_sub_login:     'Toegang tot uw verhuurdersdashboard',
auth_titre_signup:  'Account aanmaken',
auth_sub_signup:    'Begin gratis',
auth_email:         'E-mail',
auth_pwd:           'Wachtwoord',
auth_pwd_min:       'Minimaal 6 tekens',
auth_login_btn:     'Inloggen →',
auth_signup_btn:    'Mijn account aanmaken →',
auth_reset_btn:     'Resetlink verzenden →',
auth_forgot:        'Wachtwoord vergeten?',
auth_no_account:    'Nog geen account?',
auth_create:        'Account aanmaken',
auth_has_account:   'Al een account?',
auth_signin:        'Inloggen',
auth_back_login:    '← Terug naar inloggen',
auth_err_fields:    'E-mail en wachtwoord vereist.',
auth_err_pwd_min:   'Wachtwoord: minimaal 6 tekens.',
auth_ok_signup:     '✅ Account aangemaakt! Controleer uw inbox.',
auth_ok_reset:      '✅ Reset e-mail verzonden! Controleer uw inbox.',
auth_tagline:    'Eenvoudig en efficiënt vastgoedbeheer voor verhuurders.',
auth_feat1_title: 'Realtime dashboard',
auth_feat1_desc:  'Ontvangen huur, achterstanden, rendement.',
auth_feat2_title: 'Betalingsopvolging',
auth_feat2_desc:  'Markeer betalingen met één klik.',
auth_feat3_title: 'Automatische kwitanties',
auth_feat3_desc:  'PDF in enkele seconden.',

    //Placeholder
    ph_adresse:       'Vredestraat 1, 1000 Brussel',
ph_loyer:         '950',
ph_charges:       '50',
ph_valeur:        '200000',
ph_prenom:        'Sophie',
ph_nom_loc:       'Martin',
ph_email:         'sophie@email.com',
ph_telephone:     '+32 470 00 00 00',
ph_profession:    'Ingenieur',
ph_employeur:     'Bedrijf NV',
ph_contact_nom:   'Marie Dupont',
ph_notes:         'Opmerkingen, notities…',
ph_notes_doc:     'Bijv.: ondertekend op 01/01/2024',
ph_indice_ref:    'Bijv.: 892.29',
ph_indice_nom:    'Bijv.: ABEX okt 2024',
ph_indice_ref2:   'Bijv.: ABEX, IRL, CPI',
ph_nom_bail:      'Bijv.: Standaard huurcontract',
ph_note_ech:      'Bijv.: 3-6-9 huurcontract, ABEX-indexatie',
ph_note_interne:  'Loodgieter gecontacteerd op…',
ph_proprio_nom:   'Jan Janssen',
ph_proprio_adr:   'Vredestraat 1',
ph_proprio_ville: 'Brussel 1000',
ph_proprio_tel:   '+32 470 00 00 00',

    // Dashboard
    tdb_titre:      'Dashboard',
    loyers_att:     'Verwachte huur',
    encaisses:      'Geïnd',
    biens_loc:      'Panden / Actieve huurders',
    retards:        'Achterstallig',
    ce_mois:        'Deze maand',
    a_relancer:     'Op te volgen',
    loyers_mois:    'Huur deze maand',
    voir_tout:      'Alles zien',
    loc_actifs:     'Actieve huurders',
    aucun_paie:     'Geen betalingen deze maand',
    aucun_loc:      'Geen huurders',
    annee:          'Jaar',
    enc_annuel:     'Geïnd',
    taux_recouv:    'Inningspercentage',
    meilleur_mois:  'Beste maand',
    moy_mens:       'Maandelijks gemiddelde',
    sur_12_mois:    'Over 12 maanden',
    annee_compl:    'Volledig jaar',
    attendus:       'verwacht',
    aucun_enc:      'Geen',
    enc_graph:      'Inningen',
    rev_par_bien:   'Inkomsten per pand',
    aucun_enc_ann:  'Geen inningen voor',
    mois_en_cours:  'Huidige maand',
    encaisse_lbl:   'Geïnd',
    vide:           'Leeg',

    // Biens
    mes_biens:      'Mijn panden',
    todo:           'Taken',
    illimites:      'Onbeperkt',
    biens_util:     'panden gebruikt',
    ajouter_bien:   '+ Pand toevoegen',
    annuler:        'Annuleren',
    modifier_bien:  'Pand bewerken',
    ajouter_b:      '➕ Pand toevoegen',
    adresse:        'Adres',
    type_bien:      'Type',
    loyer:          'Huur (€)',
    charges:        'Kosten (€)',
    valeur:         'Waarde (€)',
    jour_ech:       'Vervaldatum',
    le_du_mois:     'De {j}e van de maand',
    enregistrer:    'Opslaan',
    enreg_en_cours: 'Opslaan...',
    modifier:       '✏️ Bewerken',
    supprimer:      '🗑️',
    rdt:            'Rendement',
    adr_loyer_req:  'Adres en huur zijn verplicht.',
    aucun_bien:     'Geen panden!',
    nb_biens:       'pand(en)',
    appartement:    'Appartement',
    studio:         'Studio',
    maison:         'Woning',
    kot:            'Kot',
    commerce:       'Handelspand',

    // Locataires
    loc_titre:      'Huurders',
    actifs:         'actief',
    inactifs:       'inactief',
    limite:         'Limiet',
    ajouter_loc:    '+ Huurder toevoegen',
    actifs_tab:     'Actief',
    inactifs_tab:   'Inactief',
    prenom:         'Voornaam',
    nom:            'Naam',
    telephone:      'Telefoon',
    bien_loue:      'Gehuurd pand',
    date_entree:    'Intrekdatum',
    tous_champs:    'Alle verplichte velden moeten ingevuld zijn.',
    desactiver:     'Deactiveren',
    reactiver:      'Reactiveren',
    dossier:        '📁 Dossier',
    whatsapp:       'WhatsApp',
    aucun_loc_act:  'Geen actieve huurders.',
    aucun_loc_in:   'Geen inactieve huurders.',
    nb_loc:         'huurder(s)',
    sorti_le:       'Vertrokken op',
    pas_email:      'Geen e-mail',
    ajout_bien_dab: '⚠️ Voeg eerst een pand toe.',
    selectionner:   '— Selecteren —',
    langue:         'Taal',

    // Confirm modals
    confirmer:      'Bevestigen',
    annuler_btn:    'Annuleren',
    suppr_def:      '{n} definitief verwijderen? Dit kan niet ongedaan worden gemaakt.',
    desact_msg:     '{n} als inactief markeren? Geen automatische huur meer.',
    react_msg:      '{n} als actieve huurder reactiveren?',
    suppr_btn:      'Verwijderen',
    desact_btn:     'Deactiveren',
    react_btn:      'Reactiveren',

    // Dossier locataire
    informations:   'Informatie',
    documents:      'Documenten',
    invite:         'Uitnodigen',
    invite_ok:      '✓ Uitgenodigd',
    infos_base:     'Basisinformatie',
    infos_comp:     'Aanvullende informatie',
    date_naiss:     'Geboortedatum',
    num_nat:        'Rijksregisternummer',
    profession:     'Beroep',
    employeur:      'Werkgever',
    contact_urg:    'Noodcontact — Naam',
    contact_tel:    'Noodcontact — Tel',
    notes:          'Interne notities',
    bail:           'Huurcontract',
    type_bail:      'Type huurcontract',
    date_sign:      'Ondertekeningsdatum',
    indice_ref:     'Referentie-index (waarde)',
    nom_indice:     'Indexnaam',
    aucun:          '— Geen —',
    enregistre:     '✅ Opgeslagen!',
    ajouter_doc:    'Document toevoegen',
    type_doc:       'Documenttype',
    notes_opt:      'Notities (optioneel)',
    cliquer_fich:   'Klik om een bestand te selecteren',
    formats_acc:    'PDF, JPG, PNG, Word — max 10 MB',
    envoi_cours:    '⏳ Uploaden…',
    nb_docs:        'document(en)',
    aucun_doc:      'Geen documenten voor deze huurder.',
    doc_locked:     '🔒 Documenten zijn beschikbaar vanaf het Starter-plan.',
    chargement:     'Laden…',
    votre_msg:      'Uw bericht…',
    envoyer:        'Verzenden',
    aucun_msg:      'Nog geen berichten. Stuur het eerste!',
    vous:           'U',
    invitation_ok:  '✅ Uitnodiging verzonden naar {email}!',
    inv_error:      'Fout bij het verzenden van de uitnodiging.',
    inv_no_email:   'Deze huurder heeft geen e-mailadres.',
    invit_le:       'Uitgenodigd op',
    entre_le:       'Ingetrokken op',
    lang_comm: 'Communicatietaal',
    emails_tab:        'E-mails',
    emails_info:       'Geschiedenis van alle e-mails verzonden naar deze huurder.',
    emails_aucun:      'Nog geen e-mails verzonden naar deze huurder.',
    emails_nb:         'e-mail(s) verzonden',
    email_generation:  'Huurgeneratie',
    email_rappel:      'Betalingsherinnering',
    email_relance:     'Aanmaning onbetaalde huur',
    email_quittance:   'Kwitantie',
    email_envoye_lbl:  '✓ Verzonden',
    email_invitation: 'Uitnodiging huurderportaal',
    doc_limit_reached: 'Limiet van {n} document(s) bereikt op het {plan} plan.',
    doc_limit_upgrade: 'Upgrade naar Pro voor onbeperkte documenten.',

    // Paiements
    suivi_loyers:   'Huuroverzicht',
    enreg_manuel:   '+ Handmatig registreren',
    enc_total:      'Geïnd (totaal)',
    en_attente:     'In afwachting',
    soldes_part:    'Openstaande gedeeltelijke saldi',
    en_retard:      'Achterstallig',
    nb_paie:        'betaling(en)',
    tous:           'Alle',
    payes:          'Betaald',
    partiels:       'Gedeeltelijk',
    att_tab:        'In afwachting',
    retard_tab:     'Achterstallig',
    paye_btn:       '✓ Betaald',
    partiel_btn:    '~ Gedeeltelijk',
    retard_btn:     'Achterstallig',
    quittance_btn:  '📄 Kwitantie',
    rouvrir_btn:    '↩ Heropenen',
    aucun_paie2:    'Geen betalingen',
    recu:           'ontvangen',
    du:             'verschuldigd',
    enreg_paie:     'Betaling registreren',
    bien_req:       'Pand *',
    mois_req:       'Maand *',
    montant_req:    'Bedrag (€) *',
    statut:         'Status',
    paye_s:         '✅ Betaald',
    pending_s:      '⏳ In afwachting',
    late_s:         '🔴 Achterstallig',
    champs_req:     'Alle velden zijn verplicht.',
    bail_cat_369:   'Residentieel 3-6-9 (Frankrijk)',
    bail_cat_9ans:  'Hoofdverblijfplaats (9 jaar)',
    bail_cat_court: 'Kortetermijn (max 3 jaar)',
    bail_cat_comm:  'Commercieel',
    bail_cat_autre: 'Andere',
    erreur_envoi: 'Fout bij verzending',

    // Partiel modal
    paie_partiel:   'Gedeeltelijke betaling',
    loyer_att:      'Verwachte huur',
    montant_recu:   'Ontvangen bedrag (€)',
    recu_lbl:       '💸 Ontvangen',
    solde_rest:     'Resterend saldo',
    contact_support:      'Contact opnemen',
    contact_support_desc: 'Vraag, bug of idee?',

    // Quittance
    quittance:      '📄 Huurkwitantie',
    locataire_lbl:  'Huurder',
    bien_lbl:       'Pand',
    periode:        'Periode',
    montant_lbl:    'Bedrag',
    paye_le:        'Betaald op',
    prop_incomplet: '⚠️ Vul uw verhuurdersinformatie in bij Instellingen voor u een kwitantie genereert.',
    envoyer_email:  '✉️ Per e-mail verzenden',
    dl_pdf:         '⬇️ PDF downloaden',
    fermer:         'Sluiten',
    envoi_ok:       '✅ Kwitantie verzonden naar {email}!',
    envoi_err:      'Fout bij het verzenden van de e-mail.',
    envoi_aussi:    'Ook per e-mail naar huurder sturen bij downloaden',
    no_email_loc:   '⚠️ Deze huurder heeft geen e-mailadres.',
    envoi_en_cours: 'Verzenden...',

    // Messagerie
    par_mois:       'maand',
    export_excel:   'Excel',
    msg_titre:      'Berichten',
    msg_sub:        'Gesprekken met uw huurders',
    nouveau_x:      'nieuw',
    nouveaux_x:     'nieuwe',
    conv_titre:     'gesprek(ken)',
    sel_conv:       'Selecteer een gesprek',
    retour:         '← Terug',

    // Échéances
    ech_titre:      'Vervaldagen',
    ech_sub:        'Huurverlengingen en indexaties om op te volgen',
    ajouter_ech:    '+ Vervaldag toevoegen',
    mark_lues:      '✓ Meldingen als gelezen markeren',
    actives:        'Actief',
    traitees:       'Behandeld',
    toutes:         'Alle',
    ajouter_e:      'Vervaldag toevoegen',
    modifier_e:     'Vervaldag bewerken',
    locataire_req:  'Huurder',
    type_req:       'Type',
    date_ech_req:   'Vervaldatum *',
    rappel_av:      'Herinnering (dagen ervoor)',
    note_opt:       'Noot (optioneel)',
    renouvellement: 'Huurverlenging',
    indexation:     'Huurindexatie',
    traite_btn:     '✓ Behandeld',
    aucune_ech:     'Geen vervaldagen',
    active_lbl:     'actief',
    traitee_lbl:    'Behandeld',
    depassee_lbl:   'Verstreken',

    // Indexation
     idx_menu: 'Indexatie',
    idx_titre: 'Huurindexatie',
    idx_soustitre: 'Automatische berekening op basis van de gezondheidsindex (België)',
    idx_aucun: 'Geen huurcontract om te indexeren op dit moment.',
    idx_calculer: 'Indexatie berekenen',
    idx_depassee: 'Vervallen',
    idx_loyer_actuel: 'Huidige huur',
    idx_indice_depart: 'Aanvangsindex',
    idx_nouvel_indice: 'Nieuwe index',
    idx_nouveau_loyer: 'Nieuwe huur',
    idx_voir_lettre: 'Brief aan huurder bekijken',
    idx_appliquer: 'Indexatie toepassen',
    idx_application: 'Toepassen',
    idx_envoyer: 'Naar huurder sturen',
    idx_envoye: 'Verzonden',
    idx_historique: 'Indexatiegeschiedenis',
    idx_locataire: 'Huurder',
    idx_date: 'Datum',
    idx_avant: 'Voor',
    idx_apres: 'Na',
    idx_verif_indices: 'Controleer of de indexen voor de betrokken maand zijn ingevuld.',
    idx_mail_objet: 'Indexatie van uw huur',
    idx_starter_desc: 'Automatische huurindexatie is beschikbaar vanaf het Starter-plan. Berekening op basis van de gezondheidsindex en vooraf ingevulde brief aan de huurder.',
    pays_lbl: 'Land',
    autre_pays: 'Andere',
    region_lbl: 'Gewest',
    region_wallonie: 'Wallonië',
    region_bruxelles: 'Brussel',
    region_flandre: 'Vlaanderen',
    peb_lbl: 'EPC / Energielabel',
    idx_hist_onglet: 'Huurverloop',
    idx_hist_aucun: 'Geen indexatie geregistreerd voor dit contract.',
    idx_hist_initial: 'Aanvangshuur',
    idx_hist_actuel: 'Huidige huur',
    idx_hist_evolution: 'Totale evolutie',
    idx_hist_indice: 'Index',
    idx_hist_manuel: 'Handmatige wijziging',
    
    // Types de baux
    baux_titre:     'Huurcontracten',
    baux_sub:       'Contractsjablonen met automatische vervaldag-generatie',
    nouveau_bail:   '+ Nieuw huurcontract',
    nom_modele:     'Sjabloonnaam *',
    categorie:      'Categorie',
    duree_mois:     'Duur (maanden)',
    preavis:        'Opzegtermijn (maanden)',
    rappel_renouv:  'Herinnering verlenging (dagen ervoor)',
    index_auto:     'Automatische indexatie',
    freq_mois:      'Frequentie (maanden)',
    indice_ref2:    'Referentie-index',
    rappel_idx:     'Herinnering indexatie (dagen ervoor)',
    creer_modele:   'Sjabloon aanmaken',
    modifier_b:     'Bewerken',
    gen_ech:        '⚡ Vervaldagen genereren',
    aucun_bail:     'Geen huurcontracten. Maak uw eerste sjabloon aan!',
    assigner_bail:  'Huurcontract toewijzen aan huurder',
    assigner_info:  'ℹ️ Het toewijzen van een huurcontract genereert automatisch vervaldagen.',
    assigner_btn:   '⚡ Toewijzen en vervaldagen genereren',
    bail_assigne:   '✅ Huurcontract toegewezen en vervaldagen gegenereerd!',
    traitement:     'Verwerken...',
    locataires_c:   'huurder(s)',

     // Tâches récurrentes
      tr_vue_taches: 'Te doen',
    tr_vue_recurrentes: 'Terugkerend onderhoud',
    tr_sous_titre: 'Plan uw onderhoud en terugkerende taken.',
    tr_ajouter: 'Nieuwe taak',
    tr_modele: 'Type taak',
    tr_titre: 'Titel',
    tr_bien: 'Betrokken pand',
    tr_tous_biens: 'Alle panden',
    tr_frequence: 'Frequentie',
    tr_mensuel: 'Elke maand',
    tr_trimestriel: 'Om de 3 maanden',
    tr_semestriel: 'Om de 6 maanden',
    tr_annuel: 'Elk jaar',
    tr_2ans: 'Om de 2 jaar',
    tr_5ans: 'Om de 5 jaar',
    tr_prochaine: 'Volgende vervaldatum',
    tr_rappel: 'Herinnering',
    tr_jours_avant: 'dagen ervoor',
    tr_note: 'Notitie (optioneel)',
    tr_aucune: 'Nog geen terugkerende taak. Voeg uw eerste onderhoud toe.',
    tr_fait: 'Klaar',
    tr_depassee: 'Verlopen',
    tr_starter_desc: 'Het plannen van terugkerend onderhoud is beschikbaar vanaf het Starter-plan. Stel herinneringen in voor ketelonderhoud, schoorsteenvegen, verzekering en meer.',

    // Calendrier
    cal_menu: 'Kalender',
    cal_titre: 'Kalender',
    cal_soustitre: 'Uw huurtermijnen, indexaties en onderhoud in één oogopslag.',
    cal_starter_desc: 'De gecombineerde kalender is beschikbaar vanaf het Starter-plan. Bekijk einde huurcontracten, indexaties en onderhoudstaken in één overzicht.',
    date_lbl: 'Datum:',

    // Décompte charges
    ch_onglet: 'Kosten',
    ch_annee: 'Jaar:',
    ch_ajouter: 'Factuur toevoegen',
    ch_categorie: 'Categorie',
    ch_montant: 'Bedrag',
    ch_date: 'Factuurdatum',
    ch_libelle: 'Omschrijving',
    ch_libelle_ph: 'Bv. Waterfactuur Q1',
    ch_recuperable: 'Kost recupereerbaar op huurder',
    ch_non_recup: 'Niet-recupereerbaar',
    ch_aucune: 'Geen factuur geregistreerd voor dit jaar.',
    ch_synthese: 'Afrekening',
    ch_provisions: 'Betaalde provisies',
    ch_total_recup: 'Recupereerbare kosten',
    ch_solde: 'Saldo',
    ch_remboursement: 'Terug te betalen aan huurder',
    ch_complement: 'Supplement verschuldigd door huurder',
    ch_reset_auto: 'Automatisch herberekenen',
    ch_enregistrer: 'Afrekening opslaan',
    ch_envoyer: 'Naar huurder sturen',
    ch_envoye: 'Verzonden',
    ch_mail_objet: 'Kostenafrekening',
    ch_annee_rattach: 'Boekjaar',
    dont_charges: 'Waarvan kosten',
    ch_pro_titre: 'Pro-functie',
    ch_pro_desc: 'De kostenafrekening is beschikbaar met het Pro-plan. Registreer uw facturen en genereer automatisch de jaarlijkse afrekening.',

    // Notifications
    notif_titre:    'Meldingen',
    notif_sub:      'Configureer automatische e-mails naar uw huurders.',
    vars_dispo:     'Beschikbare variabelen in uw sjablonen:',
    email_gen:      'Generatie-e-mail',
    le_1er_mois:    'op de 1e van de maand',
    sujet_loc:      'Onderwerp (e-mail huurder)',
    corps_loc:      'Inhoud (e-mail huurder)',
    rappel_ech:     'Herinnering voor vervaldag',
    jours_avant:    'Hoeveel dagen voor de vervaldag?',
    relance_imp:    'Opvolging onbetaalde huur',
    jours_apres:    'Hoeveel dagen na de vervaldag?',
    enreg_notif:    'Instellingen opslaan',
    enreg_ok:       '✅ Instellingen opgeslagen!',
    notif_templates_titre: 'E-mailsjablonen — verzonden in de taal van de huurder',
notif_templates_info:  'Elke huurder ontvangt de e-mail in zijn eigen taal (configureerbaar in zijn dossier).',
templates_titre: '✉️ Sjablonen',
ech_arrive_le:    'vervalt op',
ech_reste_jours:  'Nog {n} dagen om actie te ondernemen.',

     // Interventions
    interv_titre:     'Onderhoudsverzoeken',
    interv_sub:       'Verzoeken ingediend door uw huurders',
    interv_nouvelle:  'Nieuw',
    interv_en_cours:  'In behandeling',
    interv_resolue:   'Opgelost',
    interv_urgente:   '🔴 Dringend',
    interv_normale:   'Normaal',
    interv_cat_elec:  'Huishoudapparaten',
    interv_cat_plomb: 'Sanitair',
    interv_cat_chauf: 'Verwarming',
    interv_cat_elec2: 'Elektriciteit',
    interv_cat_autre: 'Andere',
    interv_repondre:  'Antwoorden',
    interv_resoudre:  'Markeer als opgelost',
    interv_note:      'Interne notitie',
    interv_aucune:    'Geen onderhoudsverzoeken',
    interv_prendre:   'In behandeling nemen',
    interv_resolues: 'Opgelost',
    voir_photo: 'Foto bekijken',
    urgent: 'Dringend',
    par_email: 'per e-mail',

    // Paramètres
    param_titre:    'Instellingen',
    param_sub:      'Deze informatie verschijnt op uw kwitanties en bepaalt de opmaak van bedragen.',
    devise_fmt:     'Valuta & Opmaak',
    devise:         'Valuta',
    apercu:         'Voorbeeld',
    infos_prop:     'Verhuurdersinformatie',
    infos_prop_sub: 'Deze informatie wordt weergegeven op alle gegenereerde PDF-kwitanties.',
    nom_complet:    'Volledige naam',
    ville:          'Stad',
    email_cpt:      'E-mail (account)',
    langue_iface:   'Interfacetaal',
    langue_sub:     'De interface wordt weergegeven in de geselecteerde taal.',
    lang_note:      '⚠️ De taal wordt toegepast na het klikken op "Opslaan".',
    module_interv_on:  'Module actief',
    module_interv_off: 'Module uitgeschakeld',
    reset_email_info: 'Een reset-e-mail wordt verzonden naar',
    module_interv_title: 'Module Interventies',
    module_interv_desc: 'Laat uw huurders onderhoudsvragen indienen via hun portaal.',
    zone_danger:          'Gevarenzone',
    suppr_compte_desc:    'Het verwijderen van uw account is onomkeerbaar. Alle gegevens (eigendommen, huurders, betalingen, documenten) worden definitief gewist.',
    suppr_compte_confirm1:'Weet u zeker dat u uw account wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    suppr_compte_confirm2:'Laatste bevestiging: alle gegevens worden definitief verwijderd. Doorgaan?',
    suppr_compte_btn:     'Mijn account verwijderen',

    // Sign Up
    auth_err_cgu:       'U moet de Algemene Voorwaarden accepteren om een account aan te maken.',
    auth_cgu_label:     'Ik accepteer de',
    auth_cgu_link:      'Algemene Gebruiksvoorwaarden',
    auth_cgu_et:        'en het',
    auth_cgu_rgpd_link: 'Privacybeleid',

    // Onboarding
    onb_bienvenue:  'Welkom bij Domavix!',
    onb_sub:        'Uw vastgoedbeheer-dashboard is klaar. Volg deze 3 stappen om in minder dan 2 minuten te beginnen.',
    onb_plan_grat:  '⭐ Gratis plan — 1 pand, 1 huurder inbegrepen',
    onb_t1:         'Uw eerste pand toevoegen',
    onb_d1:         'Adres, huur, kosten — 30 seconden.',
    onb_cta1:       '+ Pand toevoegen',
    onb_t2:         'Een huurder toevoegen',
    onb_d2:         'Koppel hem aan uw pand en stel de intrekdatum in.',
    onb_cta2:       '+ Huurder toevoegen',
    onb_t3:         'Uw huur opvolgen',
    onb_d3:         'Maandelijkse huur wordt automatisch gegenereerd.',
    onb_cta3:       'Huur bekijken',
    onb_saviez:     '💡 Wist u dat?',
    onb_tip1:       '🤖 Huur wordt automatisch gegenereerd op de 1e van elke maand',
    onb_tip2:       '📄 Genereer PDF-kwitanties met één klik op de huurpagina',
    onb_tip3:       '📱 Domavix werkt ook op mobiel — installeer het als een app!',
    onb_tip4:       '🔔 Stel automatische e-mailherinneringen in voor uw huurders',

    // Upgrade
    upg_titre:      'Pro-functie',
    upg_desc:       'Deze functie is voorbehouden aan het Pro-plan. Upgrade naar Pro om berichten, vervaldagen, huurcontracten, meldingen en de huurdersportal te ontgrendelen.',
    upg_btn:        'Pro-plan bekijken →',
    lim_att:        'Limiet van {plan}-plan bereikt',
    voir_plans:     'Plannen bekijken',
    passer_plan:    'Upgraden naar {plan} ',
    passer_pro:     'Upgrade naar Pro',
    starter_feature_titre: 'Starter-functie',
    starter_feature_desc: 'Interventieverzoeken zijn beschikbaar vanaf het Starter-plan. Upgrade zodat uw huurders problemen rechtstreeks kunnen melden.',

    // Pricing
    prix_titre:     'Eenvoudige prijzen, geen verrassingen',
    prix_sub:       'Gratis beginnen. Upgraden wanneer u wilt, annuleren wanneer u wilt.',
    prix_badge:     'Vereenvoudigd vastgoedbeheer',
    plan_act:       'Uw huidige plan',
    populaire:      '⭐ Meest populair',
    choisir:        '{plan} kiezen →',
    securise:       '🔒 Veilige betaling via Stripe · Annuleren met 1 klik · Geen verbintenis',
    envoi_erreur: 'Fout bij het verzenden van de e-mail.',
    gerer_abonnement:     'Mijn abonnement beheren →',
    gerer_abonnement_sub: 'Annuleren, plan wijzigen of betaalmethode bijwerken',
    cancel_warning_1:     'Uw',
    cancel_warning_2:     'abonnement is actief tot',
    cancel_warning_3:     'Het schakelt daarna over naar het Gratis plan.',

    // Plans
    plan_free_name:    'Gratis',
    plan_free_period:  '/altijd',
    plan_free_desc:    'Om Domavix te ontdekken met een eerste pand.',
    plan_starter_desc: 'Tot 4 woningen · PDF-kwitanties · Interventies · Excel-export · Automatische meldingen',
    plan_pro_desc:     'Tot 10 woningen · Berichtgeving huurders · Termijnen & indexatie · Huurcontracten · Banksync · Alles van Starter inbegrepen',


    // Features
    feat_1_bien:       '1 pand maximum',
    feat_5_biens:      '5 panden maximum',
    feat_10_biens: 'Tot 10 panden',
    feat_biens_illim:  'Onbeperkte panden',
    feat_1_loc:        '1 huurder',
    feat_loc_illim:    'Onbeperkte huurders',
    feat_suivi:        'Huuroverzicht',
    feat_infos:        'Info huurdersdossier',
    feat_quittances:   'PDF-kwitanties',
    feat_docs_lock:    'Huurdersdocumenten',
    feat_notif:        'E-mailmeldingen',
    feat_3_docs:       '3 documenten per huurder',
    feat_docs_illim:   'Onbeperkte documenten per huurder',
    feat_export_xl:    'Excel',
    feat_support:      'Prioritaire ondersteuning',
    plan_enterprise_title: 'Meer dan 10 panden? Laten we praten.',
    plan_enterprise_desc:  'Prijs op maat, persoonlijke begeleiding, toegewijd support.',
    plan_enterprise_cta:   '✉️ Contacteer mij',
    feat_4_biens:       'Maximaal 4 woningen',
    feat_interventions: 'Beheer van interventies',
    feat_ponto:         'Automatische huurdetectie (Ponto)',
    feat_messagerie:    'Berichtgeving huurders',
    feat_echeances:     'Termijnen & huurindexatie',
    feat_5_docs:        '5 documenten per huurder (max 5 MB)',
    feat_20_docs:       '20 documenten per huurder (max 10 MB)',
    doc_taille_max:     'Bestand te groot. Maximum toegestaan: {n} MB',
    feat_indexation: 'Automatische huurindexatie',
    feat_calendrier: 'Vervaldagenkalender',
    feat_taches_rec: 'Terugkerende onderhoudstaken',
    feat_charges: 'Jaarlijkse kostenafrekening',

    // Immeuble
    imm_onglet: 'Gebouwen',
    imm_sous_titre: 'Groepeer uw panden en verdeel de gemeenschappelijke kosten.',
    imm_ajouter: 'Nieuw gebouw',
    imm_nom: 'Naam van het gebouw',
    imm_nom_ph: 'Bv. Residentie De Linden',
    imm_adresse: 'Adres',
    imm_cle: 'Verdeelsleutel',
    imm_cle_quotite: 'Quotiteiten',
    imm_cle_surface: 'Oppervlakte (m²)',
    imm_cle_egale: 'Gelijke delen',
    imm_format: 'Formaat',
    imm_millieme: 'Duizendsten (/1000)',
    imm_pourcent: 'Percentage (/100)',
    imm_lot: 'kavel',
    imm_lots: 'kavels',
    imm_vide_titre: 'Geen gebouw',
    imm_vide_desc: 'Groepeer meerdere panden in een gebouw om automatisch de gemeenschappelijke kosten (lift, hal, collectieve verwarming) tussen de kavels te verdelen.',
    imm_aucun_lot: 'Geen kavel gekoppeld. Voeg hieronder een pand toe.',
    imm_rattacher: 'Kies een pand om te koppelen',
    imm_ajouter_lot: 'Koppelen',
    imm_total_alerte: 'Het totaal van de quotiteiten ({total}) is geen {cible}.',
    imm_normalise: 'De verdeling wordt evenredig berekend.',
    imm_col_bien: 'Pand',
    imm_col_quotite: 'Quotiteit',
    imm_col_surface: 'Oppervlakte',
    imm_col_part: 'Aandeel',
    imm_enregistrer_quotites: 'Opslaan',
    imm_enregistre: 'Opgeslagen',
    ch_privatives: 'Privatieve kosten',
    ch_quote_part: 'Aandeel gemeenschappelijke kosten',
    cc_titre: 'Gemeenschappelijke kosten',
    cc_ajouter: 'Factuur',
    cc_aucune: 'Geen gemeenschappelijke factuur voor dit jaar.',
    cc_total: 'Totaal gemeenschappelijke kosten',
    imm_cle_habitants: 'Aantal bewoners',
    cc_repartir: 'Verdelen volgens:',
    ch_presence: 'aanwezigheid',
    idx_correction_titre: 'EPC-correctie (Vlaanderen)',
    idx_loyer_plein: 'Geïndexeerde huur (standaardformule)',
    idx_facteur: 'Correctiefactor',
    idx_loyer_corrige: 'Gecorrigeerde verschuldigde huur',
    idx_irl_depart: 'Begin-IRL',
    idx_irl_nouveau: 'Nieuwe IRL',
    idx_gele_titre: 'Huur bevroren (energieverslindend pand)',
    idx_gele_inchange: 'de huur blijft ongewijzigd',
    dpe_lbl: 'EPC (energielabel)',
    departement_lbl: 'Departement',
    departement_ph: 'Bv. 75',
    irl_trimestre: 'IRL-referentiekwartaal',
    irl_annee: 'IRL-referentiejaar',
    irl_auto: 'Auto (volgens ondertekening)',
    irl_zone_tendue: 'Woning in gereguleerde zone',

    // FAQ
    faq_titre:  'Veelgestelde vragen',
    faq_q1:     'Kan ik op elk moment van plan wisselen?',
    faq_a1:     'Ja, via uw Stripe-portaal. Wijzigingen zijn onmiddellijk van kracht.',
    faq_q2:     'Hoe werkt opzegging?',
    faq_a2:     'U kunt met één klik opzeggen via uw Stripe-portaal. U behoudt toegang tot het einde van de betaalde periode.',
    faq_q3:     'Zijn mijn gegevens veilig?',
    faq_a3:     'Ja. Heeft elke verhuurder alleen toegang tot zijn eigen gegevens.',
    faq_q4:     'Biedt u een proefperiode aan?',
    faq_a4:     'Met het gratis plan kunt u onbeperkt testen met 1 pand. Geen creditcard vereist.',

    // Types de documenten
    doc_bail:          'Huurcontract',
    doc_edl_entree:    'Intredende plaatsbeschrijving',
    doc_edl_sortie:    'Uittredende plaatsbeschrijving',
    doc_caution:       'Borgstelling',
    doc_attestation:   'Domicilieattest',
    doc_fiche_paie:    'Loonstrook',
    doc_assurance:     'Verzekering',
    doc_autre:         'Overige',

    un_mois_avant:     '1 maand voor',
    deux_mois_avant:   '2 maanden voor',
    trois_mois_avant:  '3 maanden voor',
    six_mois_avant:    '6 maanden voor',
    quatorze_j_avant:  '14 dagen voor',
    infos_complementaires: 'Aanvullende informatie',
    desactivee:      'Uitgeschakeld',
    tous_les:        'Elke',
    configurable:    'configureerbaar',
    rappels:         'Herinneringen',
    sept_j_avant:    '7 dagen voor',
    jan: 'jan', fev: 'feb', mar: 'mrt', avr: 'apr', mai: 'mei', jun: 'jun',
    jul: 'jul', aou: 'aug', sep: 'sep', oct: 'okt', nov: 'nov', dec: 'dec',

    upgrade_biens_free:    'Gratis plan: 1 pand max. Upgrade naar Starter voor 4 panden.',
    upgrade_biens_starter: 'Starter plan: 4 panden max. Upgrade naar Pro voor onbeperkte panden.',
    upgrade_locs_free:     'Gratis plan: 1 huurder max. Upgrade naar Starter voor onbeperkte huurders.',
    upgrade_limite_gen:    'Limiet bereikt. Upgrade om door te gaan.',
    upgrade_limite_lbl:    '🔒 {plan} plan limiet bereikt',
    limite_lbl:            'Limiet',
    erreur_generique:'Fout :',
    doc_limite_atteinte: 'Limiet van {n} document(en) bereikt.',
    le_jour: 'de',
    interne: 'intern',
    pro_feature_titre:     'Pro Functie',
    pro_feature_desc:      'Deze functie is voorbehouden aan het Pro plan. Upgrade naar Pro om berichten, vervaldatums, huurtypen en meldingen te ontgrendelen.',
    voir_plan_pro:         'Bekijk Pro plan →',
    modifier_locataire:    'Huurder bewerken',
    aucun_bien_loc:        'Geen pand',
    erreur_upload:         'Upload fout: ',
    supprimer_doc_confirm: 'Dit document verwijderen?',
    contenu_indispo:       'Inhoud niet beschikbaar voor deze e-mail.',
    adresse_loyer_req:     'Adres en huur zijn verplicht.',
    adresse_lbl:           'Adres *',
    type_lbl:              'Type',
    loyer_eur_lbl:         'Huur (€) *',
    charges_eur_lbl:       'Kosten (€)',
    valeur_eur_lbl:        'Waarde (€)',
    biens_utilises:        '{n} / {max} panden gebruikt',
    depass_biens:          '⚠️ Plan overschreden — {n} panden voor {max}',
    depass_biens_desc:     'Uw bestaande panden blijven toegankelijk maar u kunt er geen meer aanmaken. Verwijder panden of upgrade uw plan.',
    champs_obligatoires:   'Alle velden zijn verplicht.',
    depass_locs:           '⚠️ Plan overschreden — {n} actieve huurders voor {max}',
    depass_locs_desc:      'Uw bestaande huurders blijven toegankelijk maar u kunt er geen meer toevoegen. Deactiveer huurders of upgrade uw plan.',
    suppr_loc_confirm:     '{prenom} {nom} definitief verwijderen? Dit kan niet ongedaan worden gemaakt.',
    desact_loc_confirm:    '{prenom} {nom} als inactief markeren? Geen automatische huren meer gegenereerd.',
    react_loc_confirm:     '{prenom} {nom} opnieuw activeren als actieve huurder?',
    supprimer_btn:         'Verwijderen',
    onb_titre:             'Welkom bij Domavix!',
    onb_plan_free:         '⭐ Gratis plan — 1 pand, 1 huurder inbegrepen',
    onb_etape:             'Stap {n}',
    onb_step1_titre:       'Voeg uw eerste pand toe',
    onb_step1_desc:        'Adres, huur, kosten — 30 seconden.',
    onb_step2_titre:       'Voeg een huurder toe',
    onb_step2_desc:        'Koppel ze aan uw pand en stel de intredatum in.',
    onb_step3_titre:       'Volg uw huren',
    onb_step3_desc:        'Maandelijkse huren worden automatisch gegenereerd.',
    voir_loyers:           'Huren bekijken',
    saviez_vous:           '💡 Wist u dat?',
    tip1:                  '🤖 Huren worden automatisch gegenereerd op de 1e van elke maand',
    tip2:                  '📄 Genereer PDF-kwitanties met één klik op de pagina Huren',
    tip3:                  '📱 Domavix werkt ook op mobiel — installeer het als een app!',
    tip4:                  '🔔 Stel automatische e-mailherinneringen in voor uw huurders',
    suppr_bail_confirm:    'Dit huurtype verwijderen?',
    index_desactivee:      'Uitgeschakeld',
    traitement_en_cours:   'Verwerken...',
    ech_no_bail:           'Deze huurder heeft geen toegewezen huurtype.',
    ech_bail_introuvable:  'Huurtype niet gevonden.',
    suppr_ech_confirm:     'Deze vervaldatum verwijderen?',
    generer_suivante_msg:  'Wilt u automatisch de volgende {type} vervaldatum genereren?',
    non:                   'Nee',
    oui_generer:           'Ja, genereren',
    demandes:              'aanvraag(en)',
    rouvrir:               'Heropenen',
    repondre_placeholder:  'Antwoorden aan {prenom}…',
    champs_paie_req:       'Alle velden zijn verplicht.',
    ajouter_bien_first:    '⚠️ Voeg eerst een pand toe.',
    nav_accueil:           'Startpagina',
    nav_loyers:            'Huren',
    nav_messages:          'Berichten',
    nav_plus:              'Meer',
    nav_notifications:     'Meldingen',
    nav_abonnement:        'Abonnement',
    cancel_warning:        'Uw {plan} abonnement is actief tot {date}. Het schakelt daarna over naar het Gratis plan.',
    voir_plans_btn:        'Bekijk plannen →',
    notif_activation:      'Activering',
    ajouter_bien_titre:    '➕ Pand toevoegen',
    ajouter_loc_titre:     '👤 Huurder toevoegen',
    messagerie_titre:      'Berichten',
    actif_pour_linstant:   'momenteel actief.',
    mois_idx:              'maanden',
    bail_prefill_info: 'Huurder- en eigendomsgegevens worden automatisch ingevuld.',
    date_fin_bail: 'Einddatum (optioneel)',
    garantie_lbl: 'Huurwaarborg',
    garantie_mois_lbl: 'Maanden waarborg',
    clauses_part: 'Bijzondere clausules',
    ph_clauses: 'Bv. geen huisdieren, niet roken, parkeerbeperkingen...',
    bail_apercu: 'Contractoverzicht',
    bailleur_lbl: 'Verhuurder',
    generer_bail_btn: 'Huurcontract PDF genereren',
    bail_coming_soon: 'Huurcontractgeneratie komt binnenkort beschikbaar.',
    bail_disclaimer: 'Dit document wordt gegenereerd ter informatie. Het is aanbevolen het te laten controleren door een professional of notaris voor ondertekening.',
    loyers_retard:        'Achterstallige huren',
    relances_envoyees:    'Herinneringen verzonden',
    jamais_relances:      'Nooit herinnerd',
    jamais_relance_badge: 'Nooit herinnerd',
    derniere_relance:     'Laatste herinnering',
    jour_s:               'dag(en) geleden',
    actualiser:           '↺ Vernieuwen',
    aucun_retard:         '✅ Geen achterstallige huren',
    historique:           'Geschiedenis',
    relancer:             '📧 Herinneren',
    relancer_nouveau:     '📧 Opnieuw herinneren',
    connecter_banque:     '🏦 Mijn bank koppelen →',
    filtre_tous:          'Alle',
    filtre_relances:      '🔴 Herinneringen',
    filtre_quittances:    '📄 Kwitanties',
    filtre_generation:    '📬 Generatie',
    filtre_invitations:   '📨 Uitnodigingen',
    filtre_interventions: '🔧 Interventies',

     // Locations
     locations: 'Verhuren',

     // Dashboard nouveaux widgets
    dash_repartition:        'Betalingsverdeling',
    dash_interventions:      'Lopende interventies',
    dash_aucune_interv:      '✅ Geen open interventies',
    dash_messages_nonlus:    'Ongelezen berichten',
    dash_loyers_30j:         'Verwachte huur — 30 dagen',
    dash_aucun_loyer_30j:    '✅ Geen huur verwacht in de komende 30 dagen',
    dash_calendrier:         'Kalender',
    dash_loyers_att_mois:    'Verwachte huur deze maand',
    dash_tout_encaisse:      '✅ Alles geïnd',
    dash_encaisses_mois:     'Geïnd deze maand',
    dash_aucun_encaisse:     'Geen huur geïnd',

    // Locations (panneau)
    loc_panel_infos:         'Info',
    loc_panel_bail:          'Huurcontract',
    loc_panel_echeances:     'Vervaldagen',
    loc_panel_paiements:     'Betalingen',
    loc_nouvelle:            '+ Nieuwe verhuur',
    loc_aucune:              'Geen verhuren',
    loc_active:              '✓ Actief',
    loc_terminee:            'Beëindigd',
    loc_terminees:            'Voltooid',
    loc_archivee:            'Gearchiveerd',
    loc_archivees:     'Gearchiveerd',
    loc_ouvrir:              'Openen →',
    loc_terminer:            'Beëindigen',
    loc_reactiver:           'Reactiveren',
    loc_archiver:            'Archiveren',
    loc_duree:               'Duur',
    loc_debut:               'Start',
    loc_fin:                 'Einde',
    loc_garantie:            'Waarborg',
    loc_loyer_charges:       'Huur + kosten',
    loc_aucune_ech:          'Geen vervaldagen · Vul het huurcontract in om er te genereren.',
    loc_bail_attache:        '✓ Huurcontract bijgevoegd',
    loc_generer_ech:         '📅 Vervaldagen genereren',
    loc_generation_ech_info: '📅 Genereer automatisch verlengings- en indexatievervaldagen op basis van de huurcontractinformatie.',
    loc_clauses:             'Bijzondere clausules',
    loc_bail_signe:          'Ondertekend huurcontract (PDF)',
    loc_attacher_bail:       'Klik om het ondertekende huurcontract bij te voegen',
    loc_total_encaisse:      'Totaal geïnd',
    loc_en_retard:           'Achterstallig',
    loc_aucun_paiement:      'Geen betalingen geregistreerd.',
    loc_modifier_titre:      '✏️ Verhuur bewerken',
    loc_confirm_terminer:    'Verhuur beëindigen van',
    loc_bail_requis: 'Vul het huurcontracttype en de ondertekeningsdatum in.',
    relancer_btn: 'Herinnering sturen',
    relance_ok:   'Herinnering verzonden ✓',

    // Corbeille
    corbeille_sous_titre:    'Items worden definitief verwijderd na 30 dagen',
    corbeille_vide:          '✅ Prullenbak is leeg',
    corbeille_suppr_def:     '⚠️ Definitieve verwijdering',
    corbeille_suppr_confirm: 'Definitief verwijderen',
    corbeille_irrev:         '? Deze actie kan niet ongedaan worden gemaakt.',
    corbeille_suppr_btn:     'Definitief verwijderen',
    corbeille_restaurer:     '↩️ Herstellen',
    corbeille_supprime_le:   'Verwijderd op',
    corbeille_dans:          'Definitieve verwijdering over',
    corbeille_imminente:     'Verwijdering nakend',
    corbeille_biens:         '🏠 Panden',
    corbeille_locataires:    '👤 Huurders',
    corbeille_locations:     '📋 Verhuren',
     corbeille: 'Prullenbak',
     depuis:               'sinds',
    pdf_uniquement:       'Alleen PDF',
    loc_creer:            'Verhuur aanmaken',
    todo_sub:             'Acties uit te voeren op uw portefeuille',
    todo_critique:        'Kritiek',
    todo_a_traiter:       'Te behandelen',
    todo_informatif:      'Informatief',
    todo_total:           'Totaal',
    todo_ok:              '✅ Alles up-to-date! Geen openstaande taken.',
    todo_vide_cat:        'Geen taken in deze categorie.',
    todo_aucun_doc:       'Geen documenten in het dossier',
    confirmer_btn:        '✓ Bevestigen',
    refuser_btn:          '✕ Weigeren',
    dash_aucun_msg_nonlu: '✅ Geen ongelezen berichten',
    ponto_deconnecter:    'Ontkoppelen',
    ponto_sync_now:       '🔄 Nu synchroniseren',
    ponto_compte:         'Ponto-account verbonden',
    ponto_jamais_sync:    'Nooit gesynchroniseerd',
    ponto_derniere_sync:  'Laatste sync:',
    ponto_connecte:       '✓ Verbonden',
    ponto_sync_ok:        '✅ Synchronisatie voltooid',
    ponto_confirmer:      'Handmatig te bevestigen:',
    ponto_valider_dans:   'Of valideer in',
    ponto_securise:       '🔒 Veilig opgeslagen · Nooit gedeeld',
    ponto_titre:       'Banksynchronisatie',
    ponto_desc:        'Koppel uw Ponto-bankrekening om ontvangen betalingen automatisch te detecteren. Overeenkomende huren worden als Betaald gemarkeerd zonder handmatige actie.',
    actives_tab:          'Actief',
  },
}

// ── Fonction principale de traduction ────────────────────────
// Supporte les variables : t(lang, 'suppr_def', { n: 'Jean' })
export function t(lang = 'fr', key, vars = {}) {
  const val = T[lang]?.[key] || T['fr']?.[key] || key
  return Object.entries(vars).reduce(
    (s, [k, v]) => s.replace(new RegExp(`{${k}}`, 'g'), v),
    val
  )
}

// ── Noms des mois traduits ────────────────────────────────────
export function getMoisLabels(lang = 'fr') {
  const keys = ['jan','fev','mar','avr','mai','jun','jul','aou','sep','oct','nov','dec']
  return keys.map(k => t(lang, k))
}

// ── Placeholders traduits ────────────────────────────────────
export const VARS_BY_LANG = {
  fr: { prenom: '{prenom}', nom: '{nom}', montant: '{montant}', mois: '{mois}', echeance: '{echeance}', adresse: '{adresse}', jours: '{jours}' },
  en: { prenom: '{firstname}', nom: '{lastname}', montant: '{amount}', mois: '{month}', echeance: '{duedate}', adresse: '{address}', jours: '{days}' },
  nl: { prenom: '{voornaam}', nom: '{naam}', montant: '{bedrag}', mois: '{maand}', echeance: '{vervaldatum}', adresse: '{adres}', jours: '{dagen}' },
}